const cabinetOrigin = process.env.VUE_APP_CABINET_ORIGIN

export default {
	loginHeader: {
		contactUs: 'Contáctanos',
	},

	loginPage: {
		instructionstitle1: '¡Te tenemos cubierto! ',
		instructionstitle2: ' Soluciones para ',
		instructionstitle3: ' todas tus necesidades',
		options1f: 'Accede a tu',
		options1l: 'gabinete',
		options2f: 'Ingresa a tu ',
		options2l: 'portal IB',
		options3f: 'Explora ',
		options3l: 'informes de Prop',
		termsAndConditions: 'Términos y condiciones',
		privacyPolicy: 'Política de privacidad',
		amlPolicy: 'Política AML',
		refundPolicy: 'Política de devoluciones',
		riskDisclosure: 'Divulgación de riesgos',
		complaintsProcedure: 'Procedimiento de Quejas',
		cookiePolicy: 'Política de cookies',
		userError:
			'La contraseña que ingresaste no está registrada. Por favor revisa e intenta de nuevo',
		userErrorTwo:
			'El correo que ingresaste no está registrado. Por favor revisa e intenta de nuevo',
		enterCodeBelow:
			'Introduce el código proporcionado por tu aplicación de autenticación en los recuadros a continuación.',
		enterYourCode: 'Introduce código de autenticación 2FA. // Introducir ',
		authCode: 'Código de autenticación',
		loginMobile: 'Inicia sesión en tu cuenta',
		loginOr: 'O inicia sesión con tus credenciales: ',
	},

	wellcomeComponent: {
		title: '¡Gracias por inscribirte!',
		titlesub: 'Empecemos con tu aplicación',
		subTitle:
			'Estás a punto de participar en nuestro proceso para recopilar la información necesaria para configurar tu cuenta y verificar tu identidad.',
		before: 'Antes de iniciar, prepara los siguientes documentos:',
		government: '• Documento de identidad emitido por el gobierno',
		proof: '• Comprobante de domicilio',
		signature: '• Firma digital',
		agree:
			'*Consiento que Tradeview Ltd. verifique electrónicamente mi identidad utilizando la información y los documentos proporcionados. Esta verificación será realizada por un proveedor de servicios de verificación de identidad de confianza para garantizar la precisión de los datos.',
		agreeLATAM:
			'*Consiento que Tradeview Financial Markets S.A.C. verifique electrónicamente mi identidad utilizando la información y los documentos proporcionados. Esta verificación será realizada por un proveedor de servicios de verificación de identidad de confianza para garantizar la precisión de los datos.',
		btnContinue: 'Continuar',
		btnGoBack: 'Regresar',
		btnConfirm: 'Confirmar',
		checkError: 'Marca la casilla para aceptar el tratamiento de tus datos.',
		btnContinue: 'Continue',
	},

	loginBox: {
		title: 'Inicia sesión en tu cuenta',
		logInGoogle: 'Continuar con Google',
		logInFacebook: 'Continuar con Facebook',
		or: 'O inicia sesión con tus credenciales: ',
		email: 'Correo electrónico',
		placeholderEmail: 'Ingresa tu correo electrónico',
		placeholderPassword: 'Por favor, ingresa tu contraseña',
		password: 'Contraseña',
		submit: 'Continuar',
		forgot: '¿Olvidaste tu contraseña?',
		doNotAccount: '¿No tienes una cuenta? ',
		signUp: 'Regístrate',
		tryFreeDemo: 'Probar una cuenta Demo gratis',
		remember: 'Recuérdame',
		emailError: 'Por favor, ingresa tu correo electrónico',
		passwordError: 'Por favor, ingresa tu contraseña',
		passwordToEmail: 'Por favor, revisa tu correo electrónico.',
		passwordToEmailDesc:
			'Te enviamos una contraseña temporal para restablecer tu cuenta.',
	},

	forgotPage: {
		instructionstitle1: '¡Ahorra tiempo y esfuerzo!  ',
		instructionstitle2: 'Una plataforma para cada una ',
		instructionstitle3: 'de tus necesidades',
		options1f: 'Regulado ',
		options1l: 'y seguro',
		options2f: 'Asistencia ',
		options2l: 'personalizada',
		options3f: 'Liquidez',
		options3l: ' incomparable ',
	},

	forgotBox: {
		title: 'Restablecer tu contraseña',
		email: 'Correo electrónico',
		text1: 'Ingresa tu correo electrónico registrado abajo y ',
		text2: 'te enviaremos las instrucciones para restablecer la contraseña.',
		placeholderEmail: 'Ingresa tu correo electrónico',
		badFormatEmail: `Por favor, ingresa tu correo electrónico en un formato válido. Ej. username@mail.com`,
		badEmail: 'Por favor, ingresa el correo electrónico registrado',
		wrongEmail:
			'El correo que ingresaste no está registrado. Por favor revisa e intenta de nuevo.',
		continue: 'Continuar',
		limitExceeded: 'Límite excedido',
		requiredField: 'Este campo es obligatorio',
		goBackLogIn: 'Volver al inicio de sesión',
	},

	verifiCode: {
		title: 'Verifica tu dirección de correo electrónico',
		text1:
			'Te hemos enviado un código de activación a tu correo electrónico registrado. ',
		text2:
			'Por favor, verifica tu bandeja de entrada e ingresa el código a continuación.',
		label1: 'Código de verificación',
		label2: 'Ingresa el código de 6 dígitos. Ej. 123456',
		label3:
			'El código ingresado es inválido. Por favor, revísalo e inténtalo de nuevo.',
		submit: 'Enviar',
		text3: '¿No recibiste ningún código? ',
		text4: ' Reenviar el código',
		alert1: 'Ya envíamos el código único a ',
		alert2:
			'No podemos reenviar tu código en este momento. Por favor, inténtalo de nuevo.',
		alert3: 'Código de verificación incorrecto, por favor intenta de nuevo.',
		error:
			'¡Algo salió mal! Por favor, contacta a nuestro equipo de soporte en {contactInfo}',
	},

	setPassword: {
		title: 'Establece una nueva contraseña',
		text1: 'Por favor, ingresar una nueva contraseña, ',
		text2:
			'asegurándote de que sea diferente de las contraseñas utilizadas anteriormente.',
		label1: 'Nueva contraseña',
		label2:
			'La contraseña debe tener al menos 8 caracteres e incluir al menos una minúscula, una mayúscula, un número y un carácter especial.',
		label3: 'Confirmar contraseña',
		placeholder1: 'Ingresa nueva contraseña',
		placeholder2: 'Confirmar nueva contraseña',
		error1:
			'La contraseña debe tener al menos 8 caracteres e incluir al menos una minúscula, una mayúscula, un número y un carácter especial.',
		error2:
			'Las contraseñas ingresadas no coinciden. Por favor, verifica y vuelve a intentarlo.',
	},

	setPasswordSuccess: {
		title1: '¡Tu contraseña se ha  ',
		title2: 'restablecido correctamente!',
		login: 'Iniciar sesión',
	},

	consoleHeader: {
		account: 'Cuenta #',
		balance: 'Balance',
		equity: 'Capital ',
		free: 'Margen libre',
		margin: 'Nivel de margen',
		status: 'Estado',
		hello: 'Hola',
		logout: 'Cerrar sesión',
		confirm: 'Confirmar',
		outModal: '¿Está seguro de que quiere cerrar sesión?',
		yes: 'Si',
		not: 'No',
		settings: 'Configuración',
		areYouDone: '¿Terminaste? ',
		areYouSure:
			'¿Estás seguro de que quieres cerrar sesión? Se perderán todos los cambios que no hayas guardado.',
		yesLogOut: 'Si, cerrar sesión',
	},

	// Platforms page
	platforms: {
		description:
			'Accede a la información de tu cuenta y a herramientas importantes de trading desde tu dispositivo, dándote control de tus operaciones desde cualquier lugar. Elige cómo prefieres trabajar y descarga el software o la aplicación que mejor se adapte a ti.',
		mainTitle: '¿Cómo deseas operar?',
		metatrader4: {
			desc1: 'Interfaz amigable y personalizable',
			desc2: 'Rápida velocidad de ejecución para operaciones eficientes',
			desc3: 'Colocación de órdenes sin esfuerzo',
			desc4: 'Gestión efectiva de posiciones',
			desc5:
				'Visualización de movimientos de precios para una informada toma de decisiones',
		},
		metatrader5: {
			desc1:
				'Herramientas clave de trading e información de cuenta en tu dispositivo',
			desc2: 'Alertas para no perderte eventos importantes en los mercados',
			desc3: 'Soporte para trading automatizado',
			desc4: 'Más de 80 indicadores integrados y herramientas analíticas',
			desc5:
				'Herramientas avanzadas para mejoras en tus estrategias de trading',
		},
		cTrader: {
			desc1: 'Una experiencia de trading rápida y fácil de usar',
			desc2: 'Acceso directo a los mercados de divisas',
			desc3: 'Fácil colocación de órdenes',
			desc4:
				'Visibilidad de la profundidad del mercado para una buena toma de decisiones',
			desc5: 'Tecnología avanzada para mejorar tu trading',
		},
		sterling: {
			desc1: 'Diseños personalizables y teclas de acceso rápido',
			desc2: 'Información en tiempo real del mercado nivel I y nivel II',
			desc3: 'Monitoreo en tiempo real de posiciones y ganancias/pérdidas',
			desc4:
				'Lista de seguimiento de ticker personalizable con más de 60 puntos de datos por símbolo',
			desc5: 'Paquete de gráficos con más de 90 estudios e indicadores',
		},
		lightspeed: {
			desc1: 'Múltiples fuentes de localización con precios variados',
			desc2: 'Órdenes personalizables basadas en configuraciones predefinidas',
			desc3: 'Opciones de formularios de órdenes para estrategias complejas',
			desc4:
				'Listas de seguimiento personalizables y teclas de rápido acceso para una rápida entrada de órdenes',
			desc5: 'Configuraciones completas de gestión de riesgos',
		},

		takion: {
			desc1:
				'Múltiples tipos de gráficos, marcos temporales e indicadores técnicos',
			desc2: 'Trading directo con acceso al mercado',
			desc3:
				'Escáneres de mercado en tiempo real y actualizaciones de noticias',
			desc4: 'Datos de nivel II en tiempo real y de ventas',
			desc5:
				'Capas y espacios de trabajo para operaciones de trading sin problemas',
		},

		das: {
			desc1: 'Órdenes avanzadas y gráficos en tiempo real',
			desc2: 'Gestión de múltiples cuentas',
			desc3:
				'Teclas de rápido acceso personalizables para una rápida entrada de órdenes',
			desc4:
				'Validación de órdenes de baja latencia en las principales bolsas de Estados Unidos',
			desc5: 'Acceso a datos de mercado en tiempo real',
		},

		api: {
			desc1:
				'Conexión directa y de alta velocidad a nuestros servidores de trading',
			desc2: 'Ejecución rápida y personalización de la plataforma',
			desc3: 'Control total sobre los datos enviados y recibidos',
			desc4: 'Varias opciones de órdenes de mercado y límite',
			desc5: 'Flexibilidad para tu estrategia de trading',
		},
		cqg: {
			desc1: 'Interfaces fáciles de usar',
			desc2: 'Gráficos y análisis avanzados',
			desc3:
				'Datos en tiempo real en una variedad de estilos, incluyendo mapas de calor',
			desc4: 'Gestión de órdenes y posiciones',
			desc5: 'Noticias RSS',
		},
		thanksForYourInterest: 'Gracias por tu interés',
		weWillContactYou:
			'En poco tiempo, uno de nuestros asesores se pondrá en contacto contigo para ayudarte a configurar tu cuenta demo',
		createAccountToDownload: 'Crear una cuenta',
		createAccount: 'Crear una cuenta live',
		platformNotCovered:
			'Aún no tienes una cuenta para esta plataforma o mercado. ¡Crea una cuenta para que puedas usarla!',
		btn_downd: 'Descargar',
		btn_launch: 'Abrir la versión web',
		btn_request: 'Solicitar la descarga',
		okay: 'Okay',
		continue: 'Continuar',
		requestAccount: 'Solicitar una cuenta',
		disabledOptionAlert:
			'No pudimos iniciar tu descarga. Por favor, espera 10 segundos e inténtalo de nuevo. ',
		modal_reminder: {
			title: 'Recordatorio',
			descript1: '¡Tu descarga está en proceso! ',
			descript2:
				'Usa las credenciales que te envíamos por correo electrónico para acceder.',
			descript3:
				'Si aún no haz solicitado una cuenta, recuerda que es necesaria para poder acceder, puedes solicitarla en cualquier momento. ',
			descript1sub:
				'Usa las credenciales que te envíamos por correo electrónico para acceder a ',
			descript2sub: 'Si aún no haz solicitado una cuenta,',
			descript3sub:
				'recuerda que es necesaria para poder acceder, puedes solicitarla en cualquier momento. ',
		},
		modal_send: {
			title: 'Tu solicitud ha sido enviada con éxito',
			descript:
				'¡Gracias por tu interés! En poco tiempo nos pondremos en contacto contigo para ayudarte a configurar la plataforma que seleccionaste. ',
		},
		acessPlatforms:
			'Necesitarás una cuenta para acceder a estas plataformas, puedes solicitarla',
		acessPlatformsContinue: '',
		webVersionModal: 'Abrir la versión web',
		toAccess:
			'Usa las credenciales que te envíamos por correo electrónico para acceder a MT5. Si aún no haz solicitado una cuenta, recuerda que es necesaria para poder acceder, puedes solicitarla en cualquier momento.',
		selectTypeAccount:
			'Selecciona el tipo de cuenta para la cual quieres abrir la versión web:',
		live: 'Real',
		demo: 'Demo',
		launch: 'Abrir',
	},

	//History page
	history: {
		titleH: 'Tu actividad ',
		periodTimeL: 'Periodo de tiempo',
		periodTimeP: 'Todo el historial ',
		typeL: 'Tipo',
		typeP: 'Selecciona el tipo',
		platformL: 'Plataforma',
		platformP: 'Selecciona una plataforma',
		accountL: 'Cuenta de trading',
		accountP: 'Número de cuenta',
		fromL: 'Desde',
		fromP: 'mm/dd/yyyy',
		toL: 'Hasta',
		toP: 'mm/dd/yyyy',
		clearBtn: 'Borrar',
		applyBtn: 'Aplicar',
		exportBtn: 'Exportar',
		getBtn: 'Aplicar filtro ',
		optionsAccounts: 'Selecciona tu cuenta de trading',
		infoAlertD: 'Selecciona una cuenta para ver sus movimientos aquí. ',
		noHistoryYet1: 'Los filtros seleccionados para la cuenta',
		noHistoryYet2: 'no tienen ningún historial aún',
		platformAlertD:
			'Ten en cuenta: En el filtro y la tabla debajo, solo se mostrarán las cuentas de las plataformas MT4, MT5 y cTrader. Si deseas acceder al historial de cuentas en otras plataformas, puedes hacerlo dentro de sus respectivas plataformas. ',
		accountTypeH: 'Tipo de cuenta',
		accountTypeP: 'Selecciona un tipo de cuenta',
		alertExport: 'Tu información se exportó con éxito',
		btnFilter: 'Filtros',
		alertPlatforMobile:
			'Ten en cuenta: Solo las cuentas de MT4, MT5 y cTrader se muestran debajo. Puedes acceder al historial de trading de otras plataformas en las respectivas. ',
		modalHeader: '¿Estás seguro de que quieres salir?',
		modalDescription:
			'Si te vas ahora, sin terminar el proceso de creación de cuenta, perderás todo lo que has avanzado.',
		btnModalCancel: 'Cancelar',
		btnModalYes: 'Si, estoy seguro',
		filterbyactivity: 'Filtrar por tipo de actividad',
		accountTooltip:
			'El número de cuenta asociado con el movimiento. En el caso de transferencias, el icono',
		accountTooltip2:
			'representa transferencias que ingresaron a tu cuenta consultada, y',
		accountTooltip3: 'transferencias que salieron de tu cuenta.',
		accountTooltipIn:
			'Una transferencia que ingresó a tu cuenta consultada desde la cuenta de origen que se indica en esta columna.',
		accountTooltipOut:
			'Una transferencia que salió de tu cuenta consultada y fue enviada a la cuenta de destino que se indica en esta columna.',
		selectActivity: 'Selecciona actividad',
	},

	// Withdraw page
	withdraw: {
		sourceAccount: 'Cuenta de origen',
		currency: 'Divisa',
		currencyType: 'Tipo de divisa',
		details: 'Detalles del banco',
		beneficiaryDetails: 'Detalles del banco beneficiario',
		swiftt: 'Swift',
		branch: 'Nombre de la sucursal',
		branchCode: 'Nombre de la sucursal',
		enterbranch: 'Ingrese su código de sucursal',
		province: 'Provincia',
		city: 'Ciudad',
		bank: 'Banco DBS ',
		bankK: 'Banco',
		bankTransfer: 'Selecciona un banco para tu transferencia',
		withdrawFunds: 'Retira tus fondos',
		withdrawalMethod: 'Método de retiro ',
		withdrawalAmmount: 'Valor disponible para retirar',
		keepInMind: 'Ten en cuenta:',
		withdrawalCalendar:
			'Los Introducing brokers están limitados a dos retiros por mes calendario, con un valor mínimo de retiro de $100 USD o su equivalente en la divisa base. A los retiros adicionales dentro del mismo mes calendario se les cobrará una tarifa de procesamiento de $50.',
		withdrawalMustMatchDeposit:
			'El método de retiro seleccionado debe coincidir con el método de depósito. Para depósitos con tarjeta de crédito y billetera digital, el valor de retiro no puede superar el valor del depósito original.',
		beneficiaryName: 'Nombre del beneficiario',
		beneficiaryAccount: 'Cuenta del beneficiario',
		bankAddress: 'Dirección del banco',
		enterBankAddress: 'Dirección del banco',
		enterBeneficiaryName: 'Ingresa el nombre del beneficiario ',
		beneficiaryAddress: 'Dirección del beneficiario',
		enterBeneficiaryAddress: 'Ingresa la dirección del beneficiario',
		enterYourAddress: 'Ingresa la dirección del beneficiario',
		accountNumber: 'Número de cuenta',
		iban: '(IBAN)',
		enterAccountNumber: 'Ingresa tu número de cuenta',
		bankName: 'Nombre del banco ',
		enterBankName: 'Ingresa el nombre del banco ',
		swiftCode: 'Código Swift',
		enterSwiftCode: 'Ingresa el código Swift de tu banco ',
		abaNumber: 'Número ABA',
		enterAbaNumber: 'Ingresa tu número ABA bancario',
		sortCodeClabe: 'Código de clasificación/CLABE',
		enterSortCodeClabe: 'Ingresa tu código de clasificación/CLABE',
		referenceNumber: 'Número de referencia',
		enterReferenceNumber: 'Ingresa tu número de referencia',
		associatedEmail: 'Correo electrónico asociado ',
		associatedEmailLabel: 'Correo electrónico asociado ',
		enterAssociatedEmailAccount: 'Ingresa tu correo electrónico asociado',
		doYouNeedIntermediary: '¿Necesitas un banco intermediario?',
		selectAnOption: 'Selecciona una opción',
		pleaseSelectAnOption: 'Por favor, Selecciona una opción',
		enterCashAmount: 'Ingresa un valor',
		helperCashTransfer:
			'Mínimo 10 USD. Las transferencias superiores a 25K requieren revisión manual.',
		intermediaryBank: 'Detalles del banco intermediario',
		intermediaryBankk: 'Banco intermediario',
		ifNeeded: '(Si aplica)',
		intermediaryBankName: 'Nombre del banco intermediario',
		banescoAccountName: 'Nombre de la cuenta',
		enterAccountName: 'Ingresa el nombre de tu cuenta',
		enterBankName: 'Ingresa el nombre de tu banco',
		clabe: 'CLABE',
		clabealias: '(Número de cuenta)',
		enterclabe: 'Ingrese su CLABE',
		pesosAccount: 'Número de cuenta en pesos',
		enterIntermediaryBankName: 'Ingresa nombre del banco intermediario',
		intermediaryBankAddress: 'Dirección del banco intermediario',
		enterintermediaryBankAddress: 'Ingresa nombre del banco intermediario',
		ibanNumber: 'Número de IBAN',
		enterIbanNumber: 'Ingresa tu número de IBAN ',
		withdrawalCompleted: 'Tu retiro está completo ',
		withdrawalIsComplet: 'Retiro en estudio',
		withdrawalIsCompletDescription:
			'Tu retiro está siendo revisado. Nuestro equipo se pondrá en contacto con usted por correo electrónico una vez finalizado el proceso de retiro.',
		withdrawalCompletedDescription:
			'Muy pronto tus fondos estarán disponibles en tu cuenta destino. El tiempo de procesamiento puede variar dependiendo del método de retiro seleccionado. ',
		withdrawNotCompleted: 'No fue posible completar tu retiro',
		withdrawNotCompletedDescription:
			'Ocurrió un problema mientras procesabamos tu retiro. Por favor, verifica la información del retiro e inténtalo nuevamente. Si el problema continúa, ',
		contactUs: 'contáctanos.',
		goToMyAccount: 'Ir a mi cuenta',
		creditCardDetails: 'Detalles de la tarjeta de crédito',
		important: 'Importante: ',
		withdrawalsExceeding:
			'Los retiros que superen el valor de tu depósito inicial, no podrán ser procesados por medio de tarjeta de crédito. Con este método, solo puedes retirar el mismo valor que depositaste. Para retirar ganancias, por favor, usa un método de retiro alternativo.',
		creditCardLastDigits: 'Últimos 4 dígitos de tu tarjeta de crédito ',
		enterCreditCardLastDigits:
			'Ingresa los últimos 4 digitos de tu tarjeta de crédito ',
		netellerAccountDetails: 'Detalles de tu cuenta de Neteller',
		netellerComission:
			'2% en depósitos y retiros - Excención de tarifas si los fondos se mantienen en la cuenta durante 3 meses o más, o si cumples con el requisito mínimo de lotes (contacta al gerente de la cuenta para obtener ayuda con el cálculo de los lotes).',
		netellerComissionMena:
			'Nos gustaría informarte que, debido al aumento de costos asociados con Neteller, se aplicará una tarifa del 1% en todos los depósitos y retiros realizados a través de Neteller. Las tarifas pueden ser exoneradas en ciertas circunstancias después de una revisión de tu cuenta con tu representante de Tradeview.',
		skrillAccountDetails: 'Detalles de tu cuenta de Skrill',
		upholdAccountDetails: 'Detalles de tu cuenta de Uphold',
		bitwalletAccountDetails: 'Detalles de tu cuenta de Bitwallet',
		interacAccountDetails: 'Detalles de tu cuenta de Interac e-Transfer',
		interacHelpMsg: '*Marca registrada de Interac Corp. Usada bajo licencia.',
		upholdComission:
			'Si envías a una cuenta de Uphold: No aplica el cobro de tarifa. Si envías a otra billetera de criptomonedas: TV no cobra tarifas, pero Uphold cobra las siguientes: Tarifa de conversión (1.05%), Tarifa de red (0.0003 BTC), Tarifa de retiro (0.0004 BTC).',
		bitPayTitle: 'Detalles de tu cuenta Bitpay',
		destinationAccount: 'Cuenta destino',
		bitPayCommision:
			'El procesador de criptomonedas cobra las siguientes tarifas: Tarifa de conversión (1.05%), Tarifa de red (0.0003 BTC), Tarifa de retiro (0.0003 BTC). ',
		needYourAuth: 'Necesitamos tu autorización:',
		confirmThoughtEmail:
			'Después de enviar la solicitud del retiro, debes confirmar por medio del correo electrónico registrado en tu cuenta.',
		wallet: 'Billetera',
		enterYourWallet: 'Ingresa tu billetera',
		enteryourEmailAccount: 'Ingresa tu correo electrónico',
		sticPayAccountDetails: 'Detalles de tu cuenta de SticPay',
		voletAccountDetails: 'Detalles de tu cuenta de Volet',
		interacAccountDetails: 'Detalles de tu cuenta de Interac e-Transfer ',
		fasapayAccountDetails: 'Detalles de tu cuenta de Fasapay ',
		searchABank: 'Busca un banco',
		searchAnAccount: 'Busca una cuenta',
		ibanIfApplicable: '(IBAN, si aplica) ',
		beneficiaryBankName: 'Nombre del banco beneficiario',
		enterBeneficiaryBankName: 'Nombre del banco beneficiario',
		enterYourProvince: 'Ingresa tu provincia',
		enterYourCity: 'Ingresa tu ciudad',
		unionPayDetails: 'Detalles de UnionPay',
		jpayDetails: 'UnionPay details',
		jpayAccountDetails: 'Detalles de la cuenta JPay',
		walletAndCrypto: 'Billetera y criptomonedas',
		walletAndCryptoAlert:
			'Al hacer un retiro usando criptomonedas, se aplica una tarifa de conversión de 0.7%.',
		crypto: 'Criptomonedas',
		selectCrypto: 'Selecciona una criptomoneda',
		tag: 'Tag',
		enter: 'Ingresa',
		cryptocurrency: 'Criptomonedas',
		enterCryptocurrency: 'Ingresa la criptomoneda',
		otherCurrency: 'Otro Criptomonedas',
		enterOtherCurrency: 'Ingresa otra criptomoneda',
		areYouSure: '¿Estás seguro de que quieres salir? ',
		ifYouLeaveNow:
			'Si te vas ahora, sin terminar el proceso de creación de cuenta, perderás todo lo que has avanzado.',
		noStay: 'No, quedarme',
		yesLeave: 'Si, salir',
		requestSubmited: '¡Tu solicitud fue envíada!',
		reviewEmail:
			'Por favor, revisa la bandeja de entrada de tu correo registrado.',
		unsuccessfulWithdraw: 'No fue posible completar tu retiro',
		reviewAgain:
			'Please review your withdrawal information and try again. If the issue continues happening, ',
		amountTryAgain:
			'El valor supera el valor disponible para transferencias. Cambia el monto e inténtalo de nuevo. ',
		amountTryAgainWithdraw:
			'El monto excede el monto retirable disponible. Inténtalo otra vez.',
		minimunAmount: 'El retiro mínimo para este método es de $10 USD',
		minimunAmount100: 'El retiro mínimo para este método es de $100 USD',
		minimunAmount0: 'El retiro mínimo para este método es ejemplo 0,00001 BTC.',
		invalidEmail: 'Formato invalido de correo electronico',
		invalidAccountNumber: 'Formato de número de cuenta inválido',
		noAvailableOptions: 'No hay opciones disponibles',
		closeModal:
			'Ten en cuenta que si decides salir, se perderá todo el progreso que has hecho hasta ahora. Si planeas retirar fondos luego, deberás iniciar el proceso nuevamente. ',
		successWithdraw:
			'¡Excelentes noticias! Muy pronto tus fondos estarán disponibles en tu cuenta destino. El tiempo de procesamiento puede variar dependiendo del método de retiro seleccionado. ',
		fundCreditCard: 'Depositar con tarjeta de crédito',
		selectMethod:
			'Los métodos de retiro se refieren a las opciones disponibles para retirar fondos de tu cuenta. Puedes retirar a tu cuenta bancaria, tu tarjeta de crédito, tu billetera digital o tu billetera de criptomonedas.',
		invalidCreditCardDigits: 'Dígitos de tarjeta inválidos',
		phone: 'Teléfono',
		enterYourPhone: 'Introduce tu teléfono',
		invalidPhone: 'Formato de teléfono inválido',
		modalPreferences: 'No volver a preguntar para el usuario actual',
		bankFee: '$35 USD',
		bankBranch: 'Sucursal bancaria',
		enterBankBranch: 'Ingrese tu sucursal bancaria',
		branchProvince: 'Provincia de la sucursal',
		enterBranchProvince: 'Ingresa la provincia de tu sucursal',
		branchCity: 'Ciudad de la sucursal',
		enterBranchCity: 'Ingrese la ciudad de tu sucursal',
		bankTransfer: 'Transferencia bancaria',
		bankTransferOption: 'Selecciona un banco para tu transferencia',
		creditCard: 'Tarjeta de crédito',
		cryptoWallet: 'Billetera de criptomonedas',
	},

	//Account Activity page
	accountActivity: {
		title: 'Actividad de la cuenta',
		from: '*De',
		to: '*A',
		type: 'Tipo',
		platform: 'Plataforma',
		placeholderAccount: 'Cuenta de operaciones',
		account: '*Cuenta',
		get: 'Conseguir',
		row: 'Filas por página',
		download: 'Descargar Informe',
		back: 'Atrás',
		confirm: 'Confirmar',
		close: 'Cerrar',
		error: '¡Error! No puede haber campos vacíos',
		errorTwo: '¡Error! debe seleccionar el tipo de campo.',
		history: 'La cuenta no tiene historial aun',
		activityid: 'ID de actividad',
		platfomr: 'Plataforma',
		date: 'Fecha/Hora',
		activity: 'Actividad',
		profit: 'Ganancia/Pérdida',
		timeSegmentation: 'Periodo de tiempo',
		timeFrame: 'Selecciona un periodo de tiempo',
		selectType: 'Selecciona un tipo',
		selectMarket: 'Selecciona un mercado',
		tradingAccount: 'Selecciona una cuenta de trading',
		segmentation: 'Periodo de tiempo',
		segmentationPlaceholder: 'Selecciona un periodo de tiempo',
		platformPlaceholder: 'Selecciona una plataforma',
		alert: 'Tu información se exportó con éxito',
		infoYet:
			'Los filtros que elegiste no mostraron ningun resultado. Por favor, inténtalo de nuevo ',
	},

	//tradingHistory
	tradingHistory: {
		title: 'Histórico de trading',
		from: 'Desde',
		to: 'Hasta',
		type: 'Tipo',
		platform: 'Plataforma',
		placeholderAccount: 'Cuenta de operaciones',
		account: 'Cuenta',
		get: 'Obtener',
		row: 'Filas por página',
		download: 'Informe de descarga',
		back: 'Regresar',
		confirm: 'Confirmar',
		close: 'Cerrar',
		error: 'Por favor, diligencia todos los campos requeridos',
		errorTwo: 'Por favor, selecciona un tipo',
		deal: 'Operación',
		entryTime: 'Hora de entrada',
		typr: 'Tipo',
		simbol: 'Símbolo',
		volume: 'Volumen',
		entryPrice: 'Precio de entrada',
		sl: 'S/L',
		tp: 'T/P',
		exitTime: 'Tiempo de salida',
		exitPrice: 'Precio de salida',
		commision: 'Comisión',
		bankFee: 'Comisión bancaria',
		swap: 'Swap',
		profit: 'Ganancia/Perdida',
		dateFrom: 'yyyy/mm/dd',
		dateTo: 'yyyy/mm/dd',
		openingTime: 'Horario de apertura ',
		openingPrice: 'Precio de apertura',
		stopLoss: 'Parar pérdida',
		takeProfit: 'Tomar ganancias',
		closingTime: 'Horario de cierre',
		closingPrice: 'Precio de cierre',
		comission: 'Comision',
		time: 'Fecha',
	},

	//Transfer page
	transfer: {
		mainTitle: 'Transfiere tus fondos',
		isBackValidation:
			'Nuestro equipo debe revisar su transferencia para aprobarla. Esto puede tardar hasta 24 horas del siguiente día laborable.',
		pleaseNote:
			'Ten en cuenta: Las transferencias solo se permiten entre cuentas de un mismo usuario.',
		mena: {
			consentCheck:
				'Al marcar la casilla, establezco que entiendo que he solicitado que se transfieran fondos de una de mis cuentas de Tradeview Ltd. a otra.',
		},
		ltd: {
			consentCheck:
				'Al marcar la casilla, establezco que entiendo que he solicitado que se transfieran fondos de una de mis cuentas de Tradeview Ltd. a otra.',
		},
		latam: {
			consentCheck:
				'Al marcar la casilla, establezco que entiendo que he solicitado que se transfieran fondos de una de mis cuentas de Tradeview Financial Markets S.A.C. a otra.',
		},
		markConsentCheck:
			'Por favor, marca la casilla de reconocimiento para continuar. ',
		transferAmount: 'Valor a transferir',
		transferCompleted: 'Tu transferencia está completa',
		transferReview: 'Transferencia en estudio',
		transferInCompleted: 'No pudimos completar tu transferencia',
		transferInCompletedDescription:
			'Ocurrió un problema mientras procesabamos tu transferencia. Por favor, verifica la información de tu cuenta e inténtalo nuevamente. Si el problema continúa, contáctanos. ',
		transferDescription:
			'¡Excelentes noticias! Tus fondos estarán disponibles en tu cuenta destino muy pronto.',
		transferDescriptionReview:
			'Su transferencia está siendo revisada. Nuestro equipo se pondrá en contacto con usted por correo electrónico una vez finalizado el proceso de transferencia.',
		destinationAccount: 'Cuenta destino',
		minimunAmount: 'Para este método el valor mínimo a transferir es $10.',
	},

	//Accounts
	accounts: {
		refresh: 'Actualizar balances',
		liveAccounts: 'Cuentas live',
		demoAccounts: 'Cuentas demo',
		createLive: '+ Crear una cuenta live',
		createDemo: '+ Crear una cuenta demo ',
		createAccount: 'Crear una cuenta',
		createDemoAccount: 'Crear una cuenta demo ',
		createLiveAccount: 'Crear una cuenta live',
		livee: 'Live',
		demoo: 'Demo',
		yourBalance: 'Saldo de tu cuenta',
		equityy: 'Capital ',
		marginLevel: 'Nivel de margen',
		freeMargin: 'Margen libre',
		statuss: 'Estado',
		leveragee: 'Apalancamiento',
		credit: 'Credito',
		phone: 'Telefone',
		selectLeverage: 'Selecciona un apalancamiento',
		noLiveAccount:
			'Aún no tienes una cuenta live. Escoge una que se ajuste a tus necesidades y empieza a operar ahora.',
		noDemoAccount:
			'Aún no tienes cuenta demo. Escoge una que se ajuste a tus necesidades y empieza a prácticar.',
		tradingInstrument: 'Mercado de trading',
		tradingMethodTooltip:
			"El mercado de trading se refiere a los varios tipos de mercados en los que puedes operar. Estos incluyen futuros de materias primas, acciones, CFDs, divisas, metales y mucho más. <br><br> ¿Aún no sabes cuál mercado elegir? Puedes revisarlos <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>aquí</a>",
		tradingMethodTooltip2:
			'¿Aún no sabes cuál mercado elegir? Puedes revisarlos aquí.',
		here: 'aquí',
		selectAMarket: 'Selecciona un mercado',
		platform: 'Plataforma',
		selectAPlatform: 'Selecciona una plataforma',
		cashAmount: 'Valor',
		selectCashAmount: 'Selecciona un valor',
		accountType: 'Tipo de cuenta',
		selectAnAccount: 'Selecciona un tipo de cuenta',
		currencyy: 'Tipo de divisa',
		selectACurrency: 'Selecciona un tipo de divisa',
		platformTooltip:
			'Una plataforma es un sistema de software para operar activos o instrumentos.',
		platformTooltip2:
			'¿Aún no sabes cuál plataforma elegir? Puedes revisarlas.',
		accountTypeTooltip:
			'El tipo de cuenta te permite elegir las condiciones (apalancamiento, spreads y comisiones) para tu cuenta. ',
		accountTypeTooltip2:
			'Puedes revisar las condiciones para cada tipo de cuenta. ',
		applicationCompleted: '¡Completaste tu aplicación! ',
		applicationCompletedDescription:
			'La aplicación de tu cuenta live está en revisión y será verificada en poco tiempo. Nuestro equipo se pondrá en contacto contigo en caso de necesitar documentación adicional.',
		applicationError: 'Tu aplicación no se envió',
		applicationErrorDescription:
			'Ocurrió un error durante el envío de tu aplicación.',
		applicationErrorDescription2:
			'Por favor, inténtalo de nuevo. Si el problema continúa',
		sureToLeave: '¿Estás seguro de que quieres salir?',
		processUncompleted:
			'Si te vas ahora, sin terminar el proceso de creación de cuenta, perderás todo lo que has avanzado.',
		cardPlatform: 'Plataforma',
		setDemoAccount:
			'Estamos creando tu cuenta demo. Cuando esté lista, podrás encontrar todos los detalles aquí. ',
		cancel: 'Cancelar',
		active: 'Activa',
		accountSettings: 'Configuración de la cuenta',
		changePw: 'Cambiar la contraseña de esta cuenta',
		changeLv: 'Cambiar el apalancamiento de esta cuenta',
		setLv: 'Establecer el nuevo apalancamiento de tu cuenta',
		underReview: 'Tu actualización está en revisión',
		underReviewDesc:
			'El nuevo apalancamiento de tu cuenta está en revisión y será verificado pronto. Nuestro equipo se pondrá en contacto contigo por correo electrónico una vez que el proceso haya sido completado.',
		successLev: '¡Tu apalancamiento ha sido actualizado exitosamente!',
		changePsw: 'Cambiar tu contraseña',
		forgotPw: '¿Olvidaste tu contraseña? Por favor, {contact}.',
		updatePw: '¡Tu contraseña ha sido actualizada exitosamente!',
		statusTooltip:
			'Tu cuenta puede estar inactiva por varias razones, como la falta de información o documentos solicitados. Revisa tu panel para ver posibles alertas. Si no estás seguro del motivo, por favor, {contact}.',
		failedReq: '¡Lo sentimos! Ocurrió un error',
		failedReqDesc:
			'Por favor, inténtalo de nuevo. Si el problema persiste, {contact} para obtener ayuda.',
		forex: 'Forex and CFDs',
	},

	//CreateDemoAccounts
	demoAccounts: {
		login: 'Inicio de sesión',
		pass: 'Contraseña',
		currencyTwo: 'Divisa',
		server: 'Servidor',
		ilc: 'iLC',
		xleverage: 'xLeverage',
		dontForget:
			'Recuerda guardar tus credenciales antes de hacer clic en cualquier botón o de cerrar esta ventana. Esta información también la recibirás al correo electrónico con el que registraste tu cuenta. ',
		downloadCred: 'Descargar mis credenciales',
		choosePlatform:
			'¡Excelente! Ahora estás listo para escoger y descargar una plataforma de trading',
		ifYouChooseMT4:
			'Si escogiste MetaTrader 4 para Mac OS, por favor ten cuenta que el proceso de instalación es diferente. Puedes encontrar una guía para su instalación aquí.',
		ifYouChooseMT4Continuation: '',
		thanksForRegistering: '¡Gracias por tu  registro!',
		otherStock:
			'En poco tiempo, uno de nuestros asesores se pondrá en contacto contigo para ayudarte a configurar tu cuenta demo',
		stockMT52: 'Mientras creamos tu cuenta, siéntete libre de explora ',
		stockMT53: 'nuestra página web ',
		stockMT54: 'y descubrir más acerca de Tradeview.',
		accountTypeDemo:
			"El tipo de cuenta te permite elegir las condiciones (apalancamiento, spreads y comisiones) para tu cuenta. <br><br> Apalancamiento-X 1:400 <br> ILC: 1:200 <br> Sin apalancamiento 1:1 <br><br> ¿Aún no sabes cuál tipo de cuenta elegir? Puedes revisarlas <a href='https://www.tvmarkets.com/trading/accounts/' target='_blank'>aquí</a>",
		applicationCompleted: '¡Tu cuenta demo ha sido creada!',
		pdfCredentialTitle: 'Estimado trader',
		pdfCredentialDescription1:
			'Gracias por elegirnos para iniciar tu viaje de trading.',
		pdfCredentialDescription2: 'Estamos emocionados de tenerte a bordo.',
		pdfCredentialDescription3: 'Aquí están las credenciales de tu cuenta:',
		pdfCredentialEmail: 'Email:',
		pdfCredentialPassword: 'Contraseña:',
		pdfCredentialCurrency: 'Moneda:',
		pdfCredentialServer: 'Servidor:',
		pdfCredentialInstructions: 'Instrucciones:',
		pdfCredentialInstructions2:
			'Usa tu correo electrónico y contraseña registrados',
		pdfCredentialTo: 'para',
		pdfCredentiallogin: 'iniciar sesión',
		pdfCredentialTVAccount: 'en tu cuenta de Tradeview.',
		pdfCredentialChangeP:
			'Cambia tu contraseña o configura la autenticación de 2 factores',
		pdfCredentialSettings: 'en la sección de "Configuración" del gabinete.',
		pdfCredentialFamiliarize:
			'Familiarízate con nuestra plataforma, explora las características,',
		pdfCredentialExperience:
			'y comienza a experimentar la diferencia de Tradeview.',
		pdfCredentialSupport:
			'Estamos aquí para apoyarte en cada paso del camino. Si tienes alguna pregunta',
		pdfCredentialNeed:
			'o necesitas asistencia, no dudes en contactar a nuestro equipo de',
		pdfCredentialTeam: 'soporte.',
		pdfCredentialHappy: '¡Feliz trading!',
		pdfCredentialRegards: 'Saludos cordiales,',
		pdfCredentialTVTeam: 'El equipo de Tradeview',
	},

	//Create Live Accounts
	liveAccount: {
		login: 'Inicio de sesión',
		pass: 'Contraseña',
		server: 'Servidor',
		platform: 'Plataforma',
		status: 'Estado',
		statusFalse: 'Habilitado',
		statusTrue: 'Deshabilitado',
		dontForget:
			'Recuerda guardar tus credenciales antes de hacer clic en cualquier botón o de cerrar esta ventana. Esta información también la recibirás al correo electrónico con el que registraste tu cuenta. ',
		downloadCred: 'Descargar mis credenciales',
		applicationCompleted: '¡Tu cuenta live ha sido creada!',
	},

	//credit card
	credit: {
		edit: 'Editar',
	},

	//Banck Transfer add found Skrill
	addFounds: {
		amount: 'Valor',
	},

	//fidelity
	fidelity: {
		routingNum: 'Número de ruta',
		swiftCodebic: 'Código Swift/BIC',
		disclaimer:
			'Estas instrucciones de depósito son para el uso exclusivo de residentes de las Islas Caimán. Si no estás envíando dinero desde las Islas Caimán, por favor selecciona otro banco. ',
	},

	//Bbva
	bbva: {
		ruc: 'RUC',
		accountninfo: '0011-0351-0100035781',
		nameBenef: 'Nombre del beneficiario',
		interbank: 'Número interbancario (CCI)',
	},

	//deposit
	deposit: {
		title: 'Selecciona un método de depósito',
		depositMethod: 'Método de depósito',
		processingCards: 'Tiempo de procesamiento',
		fee: 'FEE',
		crypto: 'Cripto',
		digitalWallets: 'Billetera digital',
		cardTransfer: 'Tarjeta',
		wireTransfer: 'Transferencia bancaria',
		btnDepositFunds: 'Depositar',
		selectAnOption: 'Selecciona una fuente de financiación',
		depositUnderReview: 'Depósito en revisión',
		depositUnderReviewDescription:
			'Tu depósito está actualmente en revisión. Nuestro equipo se pondrá en contacto contigo por correo electrónico una vez que se complete el proceso de depósito.',
		depositUnderReviewErrorDescription:
			'Hemos encontrado un problema al procesar tu depósito. Por favor, verifica tu información de pago e inténtalo nuevamente. Si el problema persiste, contáctanos.',
		depositCompleted: '¡Tu depósito está completo!',
		depositCompletedDescription:
			'Pronto tus fondos estarán disponibles en tu cuenta destino. El tiempo de procesamiento puede variar dependiendo del méotodo de deposito seleccionado. ',
		despositInCompletedDescription:
			'Hemos encontrado un problema al procesar tu depósito. Por favor, verifica tu información de pago e inténtalo nuevamente. Si el problema persiste,',
		contactUs: 'contáctanos.',
		depositNotCompleted: 'Tu deposito no ha sido completado',
		depositNotCompletedDescription:
			'Por favor, revisa la información proporcionada e intenta nuevamente. Si el problema continua, contáctanos.',
		keepInMind: 'Ten en cuenta: ',
		depositWithClick: 'O deposita fácilmente con un solo clic o un vistazo.',
		keepInMindTC:
			'Puedes realizar hasta 5 transacciones en un período de 24 horas.',
		ltd: {
			depositDisclaimer:
				'Las perdidas pueden superar el monto de la inversión inicial. Los depósitos de terceros NO son aceptados. Todos los depósitos deben ser realizados por el titular de la cuenta. La divisa predeterminada de la plataforma de trading es Dólar estadounidense. Tradeview Ltd. se reserva el derecho a devolver/reembolsar los depósitos hechos con tarjeta de crédito en vez de procesar un retiro. ',
		},
		latam: {
			depositDisclaimer:
				'Las perdidas pueden superar el monto de la inversión inicial. Los depósitos de terceros NO son aceptados. Todos los depósitos deben ser realizados por el titular de la cuenta. La divisa predeterminada de la plataforma de trading es Dólar estadounidense. Tradeview Financial Markets S.A.C. se reserva el derecho a devolver/reembolsar los depósitos hechos con tarjeta de crédito en vez de procesar un retiro.',
		},
		accountNumberTitle: 'Número de cuenta de trading',
		accountNumberDescription: 'Selecciona la cuenta a la que quieres depositar',
		currencyTitle: 'Tipo de divisa',
		currencyDescription: 'Selecciona un tipo de divisa',
		amountTitle: 'Valor',
		amountDescription: 'Ingresa un valor ',
		phoneNumberTitle: 'Número de teléfono',
		confirmTitle: 'Revisa los detalles de tu transacción',
		confirmDescription:
			'Asegúrate que los detalles de la transacción estén correctos: ',
		upholdCommission:
			'Los usuarios son responsables de cubrir las tarifas de transacción de criptomonedas. El valor de las tarifas dependen del valor a transferir. ',
		upholdBanningTitle: 'Geografías no disponibles',
		upholdBanningDescription:
			'Uphold no ofrece sus servicios a residentes de los siguientes países:',
		depositAmount: 'Ingresa el monto de tu depósito.',
		btcAlertTitle: 'Comisión de depósito BTC',
		btcAlertMessage:
			'Se aplicará una tarifa de conversión de BTC Fiat a todas las transacciones. La tarifa es del 1% para transacciones de hasta $250,000 y del 1.5% para transacciones superiores a $250,000.',
		upholdWarningTitle: 'Comisión directa de depósito de BTC a Tradeview',
		upholdWarningMessage:
			'La tarifa de conversión Fiat de BTC es del 1% para todas las operaciones de hasta $250K, y del 1.5% para todos las operaciones superiores a $250K',
		bitPayCommission:
			'Los usuarios asumen las tarifas de transacciones criptográficas (los valores dependen del monto de la transferencia).',
		bitPayWarningTitle:
			'El procesador de criptomonedas cobra las siguientes tarifas: ',
		bitPayWarningMessage:
			'Tarifa de conversión: 1.05%, Tarifa de red: 0.0003 BTC, Tarifa de retiro: 0.0003 BTC.',
		bitpayFooterInfo:
			'Ten en cuenta: Tradeview no se hace responsable por ninguna ganancia o perdida en la que se incurra con el cambio de divisa durante la transacción.',
		interacFooterInfo:
			'Tradeview Financial Markets S.A.C. se reserva el derecho de devolver/reembolsar depósitos realizados mediante tarjetas de crédito en lugar de procesar un retiro',
		tetherWarningTitle: 'Comisión',
		tetherWarningMessage:
			'Al hacer un depósito usando criptomonedas se aplica una tarifa de conversión del 0.7%.',
		copied: '¡Copiado!',
		validateDeposit:
			'Para validar tu depósito, envía a tu broker el recibo de la transacción cuando esté completa. Después de la validación, tus fondos serán rápidamente agregados a tu cuenta de trading, garantizando un proceso eficiente y sin inconvenientes.',

		tetherHashTitle: 'Hash',
		tetherHashDescription: 'Ingresa tu hash',
		tetherTooltip:
			'El hash es un código compuesto por números y letras que son generados aleatoreamente a través de criptografía. ',
		netellerFooterInfo:
			'Las pérdidas pueden exceder la cantidad inicial invertida. No se aceptarán depósitos de terceros. Todos los depósitos deben ser realizados por el titular de la cuenta. La denominación de la plataforma de negociación es el dólar estadounidense. Tradeview Ltd. se reserva el derecho de devolver/reembolsar los depósitos realizados mediante tarjetas de crédito en lugar de procesar un retiro.',
		fasapayAccountTitle: 'Cuenta Fasapay',
		fasapayAccountDescription: 'Ingresa tu id FasaPay cuenta',
		jpayFooterInfo: 'Currency exchange rate: 1 USD = 7 CNY(RMB)',
		addressTitle: 'Dirección',
		zipCodeTitle: 'Código zip',
		zipCodeDescription: 'Ingresa tu código zip ',
		countryTitle: 'País',
		countryDescription: 'Selecciona tu pais',
		cityTitle: 'Ciudad',
		cityPlaceholder: 'Selecciona tu ciudad',
		skrillFooterInfo:
			'Las pérdidas pueden exceder la cantidad inicial invertida. No se aceptarán depósitos de terceros. Todos los depósitos deben ser realizados por el titular de la cuenta. La denominación de la plataforma de negociación es el dólar estadounidense. Tradeview Ltd. se reserva el derecho de devolver/reembolsar los depósitos realizados mediante tarjetas de crédito en lugar de procesar un retiro.',
		bitwalletFooterInfo:
			'Las pérdidas pueden exceder la cantidad inicial invertida. No se aceptarán depósitos de terceros. Todos los depósitos deben ser realizados por el titular de la cuenta. La denominación de la plataforma de negociación es el dólar estadounidense. Tradeview Ltd. se reserva el derecho de devolver/reembolsar los depósitos realizados mediante tarjetas de crédito en lugar de procesar un retiro.',
		clickBank:
			'Selecciona el nombre de tu banco para acceder a la información esencial de tu cuenta e iniciar el depósito a través de la plataforma del banco. Cuando se complete la transferencia, envía el recibo de la transacción a tu broker. Una vez validado, agregáremos tus fondos a tu cuenta de trading.  ',
		banks: 'Bancos',
		processingTime: 'Tiempo de procesamiento:',
		commision: 'Comisión:',
		bankProcessingTime:
			'Tiempo de procesamiento: aproximadamente de 1 a 2 días hábiles',
		bankCommision: 'Comisión: No',
		sameDay: 'En el mismo dia',
		depositInstructions:
			'Estas instrucciones de depósito son para el uso exclusivo de residentes de las Islas Caimán. Si no estás envíando dinero desde las Islas Caimán, por favor selecciona otro banco. ',
		downloadInfo: 'Descargar información',
		intermediaryBank: 'Nombre del banco intermediario',
		intermediarySwift: 'Swift intermediario',
		beneficiarySwift: 'Swift beneficiario:',
		beneficiaryBank: 'Nombre del banco beneficiario',
		paymentProvider: 'Dirección del proveedor del pago ',
		accountHolder: 'Nombre del titular de la cuenta ',
		virtualIban: 'IBAN virtual ',
		bic: 'BIC',
		createLiAcc: 'Crear una cuenta live',
		waitTitle: 'Cargando una nueva pestaña',
		waitDescription:
			'Por favor no cierres esta ventana. Una nueva pestaña se abrirá automaticamente para que continues el proceso. Puedes continuar navegando o esperar aquí mientras tanto.',
		depositTypeTitle: 'Selecciona un tipo de deposito',
		depositTypeDescription:
			'Elige el tipo de deposito que prefieres y el método de pago correspondiente',
		typeCash: 'Pago en efectivo',
		typeBankTransfer: 'Transferencia bancaria',
		countryBankTitle: 'Método de pago',
		countryBankDescription: 'Seleccionar un método de pago',
		minimumAmount: 'El minimo valor para ',
		maximumAmount: 'El maximo valor para',
		is: 'es',
		pleaseNote: 'Por favor ten en cuenta: ',
		withdrawalchooseMatch:
			'El método de retiro que elijas en el futuro debe ser el mismo que el método de deposito que elijas ahora.   ',
		notResponsibleDuringTransactions:
			'Tradeview no se hace responsable de las ganancias o perdidas que resulten del cambio de divisa durante la transacción.',
		minDeposit: 'El monto mínimo de depósito para este método es de $100.00',
		creditCards: 'Tarjetas de crédito',
		cryptos: {
			comission: {
				title: 'Comisión',
				text: 'Tradeview no cobra una tarifa de depósito. Hay una tarifa de cambio del 0,7% cobrada por nuestro procesador.',
			},
			scanText1:
				'Escanea este código QR usando la función de escaneo en tu aplicación de intercambio',
			scanText2:
				'o copia manualmente la dirección de criptomoneda a continuación:',
			copyText:
				'Copia la dirección de criptomoneda a continuación y pégala en tu aplicación de intercambio:',
		},
		processTimeSameDay: 'El mismo día',
		processTimethreeDay: 'Hasta 3 días',
		commisionYes: 'Sí',
		commisionNo: 'No',
		onReviewTitle: 'Depósito en revisión',
		onReviewText:
			'Tu depósito está ahora en revisión. Nuestro equipo se pondrá en contacto contigo por correo electrónico una vez que el proceso de depósito haya finalizado.',

		bitPayFees: 'El criptoprocesador cobra las siguientes comisiones:',
		bitPayExchange:
			'Tasa de intercambio: 1.05% <br> Tasa de red: 0.0003 BTC <br> Tasa de retiro: 0.0003 BTC',
		minimumAndMaxiumAmountInterac: 'Mín. $75 CAD - Máx. $9,999 CAD',
		minumumAndMaxiumAdversInterac:
			'Interac tiene un depósito mínimo de $75.00. Cualquier fondo inferior a $75.00 será rechazado.',
		routingNumber: 'Número de ruta (ABA)',
		beneficiaryBankAddress: 'Dirección del banco beneficiario',
		beneficiaryAccountNumber: 'Número de cuenta del beneficiario',
		beneficiaryAccountName: 'Nombre de la cuenta beneficiaria',
		paymentDetailsFFC: 'Datos de pago FFC',
		iban: 'IBAN',
		swiftBic: 'SWIFT/BIC',
		currencies: 'monedas',
		sortCode: 'código de clasificación',
		entersortCode: 'Por favor, ingresa tu código de clasificación',
		beneficiary: 'Beneficiario',
		beneficiaryIBAN: 'Beneficiario IBAN/Cuenta',
		cci: 'CCI',
		moreInformationTitle: 'Información adicional requerida',
		moreInformationText:
			'Cuando el total de tus depósitos alcance los 25,000 USD o más, se requerirá una verificación adicional única. Para completar tu depósito, haz clic en "Continuar" y proporciona los detalles solicitados sobre el empleo y la situación financiera.',
		moreInformationTextLTD:
			"Se requiere una verificación adicional única. Para completar su depósito, haga clic en 'Continuar' y proporcione los detalles requeridos de empleo y financieros.",
		selectMethod: 'Proveedor de pago con tarjeta',
		cryptoMena:
			'Esta información solo se requiere una vez para los pagos de criptomonedas.',
		noOptions: 'No hay opciones disponibles',
		digitalWalletsDisclaimer:
			'• Las pérdidas pueden exceder el monto inicial invertido. <br> • NO se aceptarán depósitos de terceros. Todos los depósitos deben ser realizados por el titular de la cuenta. <br> • La denominación de la plataforma de trading es el Dólar Americano.',
		continueWithMyExchangeApp: 'Continuar con mi aplicación de intercambio',
		continueWithPayX: 'Continuar con PAY X',
		orDepositDirectly: 'O depositar directamente:',
		maximumAmountPSE_COL:
			'Para el método de pago PSE, el monto máximo es de 600 USD.',
		swiffyFooterInfo:
			'Tradeview Ltd. se reserva el derecho de devolver/reembolsar los depósitos realizados con tarjetas de crédito en lugar de procesar un retiro.',
		payWith: 'Pagar con',
		typeOfCard: 'Tipo de tarjeta',
		debitCard: 'Tarjeta de débito',
		creditCard: 'Tarjeta de crédito',
		continueAutoDeposit: 'Continuar con depósito automático',
	},

	//Email
	email: {
		company: 'Noticias de la empresa',
		selectOne: 'Noticias de Trading (',
		selectTwo: "Surf's Up!",
		update: 'Guardar',
		manageSubscription:
			'Gestiona tus suscripciones aquí. Selecciona los temas de los que deseas recibir información en el boletín de Tradeview.',
		dontReceiveEmails:
			"En caso de no querer recibir más correos electrónicos en ninguno de los temas listados debajo, solo desmárcalos. No olvides dar clic en el botón de 'Guardar'.",
	},

	//password
	password: {
		title: 'Cambiar tu contraseña',
		subTitle:
			'Para cambiar tu contraseña debes solicitar un código único a tu correo electrónico registrado.',
		request: 'Solicitar código',
		submit: 'Enviar',
		code: 'Código',
		current: 'Contraseña actual',
		confirm: 'Confirma tu nueva contraseña',
		setPasswordPreference: 'Configurar tus preferencias de cuenta',
		changePasswordDescription:
			'Gestiona tus suscripciones, cambia la configuración y protege la seguridad de tu cuenta.',
		mailingSubscriptions: {
			title: 'Tus suscripciones de correo electrónico',
			description:
				'Gestiona tus suscripciones aquí. Recibe directo a tu bandeja de entrada, análisis e información clave acerca de los mercados y de Tradeview para mantenerte al día. ',
			subscriptionUpdated:
				'La configuración de tus suscripciones ha sido actualizada',
			subscriptionError: 'Ups! Algo salió mal, por favor contacte al soporte',
		},
		passwordSettings: {
			title: 'Configuración de tu contraseña',
			description:
				'Gestiona la configuración de tu contraseña para garantizar la seguridad de tu cuenta. Desde aquí puedes cambiarla cuando quieras. ',
		},
		factor2Verification: {
			title: 'Establece autenticación doble en tu cuenta',
			description:
				'Fortalece la seguridad de tu cuenta con este protocolo. Con la autenticación doble evitas el acceso no autorizado a tu cuenta solicitando un código de seguridad adicional cada vez que inicies sesión.',
			firstStepTitle: 'Paso 1: Descarga la aplicación móvil de autenticación',
			firstStepFirstParagraph:
				'Descarga la aplicación de autenticación en tu celular. Recomendamos buscar Google Authenticator en Play Store o App Store. ',
			firstStepSecondParagraph:
				'Cuando habilites la autenticación de factor doble (2FA), deberás ingresar tu contraseña al igual que un código que va a aparecer en la aplicación Google Authenticator.',
			turnOn: 'Habilitar',
			secondStepTitle: 'Paso 2: Ingresa el código de autenticación',
			scanQRCode:
				'Escanea el código QR usando la aplicación Google Authenticator',
			enterCodeManually:
				'Ingresa el código de 6 dígitos que se muestra en la aplicación de autenticación',
			invalidCode:
				'El código que ingresaste no es válido. Por favor, intenta de nuevo',
			authCompleted:
				'Habilitaste correctamente el proceso de autenticación doble',
			disable: 'Deshabilitar',
			succesfullyActivatedAuth:
				'¡Buen trabajo! Configurando la doble autenticación agregaste una capa adicional a la seguridad de tu cuenta. Si en algún momento decides cambiar esta configuración, simplemente da clic en el botón deshabilitar',
			deactivatedNotification:
				'Tu autenticación de factor doble ha sido desactivada',
			insertCode: 'Ingresa el código 2FA',
			downloadAuth: 'Descarga Google Authenticator',
			enterAuthCode: 'Ingresa tu código de autenticación',
			codeSuccess: 'Código ingresado con éxito en nuestra plataforma ',
		},
		accountPreferences: 'Preferencias de tu cuenta',
		changeYoutPassword: 'Cambiar tu contraseña',
		requestChangePassword:
			'Para cambiar tu contraseña debes solicitar un código único a tu correo electrónico registrado.',
		requestCode: 'Solicitar código',
		didntGetIt: '¿No recibiste el código?',
		tryAgain: 'Inténtalo de nuevo',
		enter6DigitCode: 'Ingresa el código de 6 dígitos. Ej. 123456',
		enterValidOTP:
			'El código que ingresaste no es válido. Por favor, inténtalo de nuevo. ',
		notYourCurrentPassword: ' Esta no es tu contraseña actual ',
		passwordConditions:
			'Las contraseñas deben tener al menos 8 caracteres e incluir al menos una mayúscula, una minúscula, un número y un carácter especial.',
		passwordsDontMatch:
			'Las contraseñas que ingresaste no coinciden. Por favor, revisa e intenta de nuevo.',
		newPassword: 'Nueva contraseña',
		confirmPassword: 'Confirma tu contraseña ',
		passwordSuccessfulyChanged: '¡Tu contraseña fue actualizada éxitosamente!',
		sampleEmail: 'Ya envíamos el código único a ',
		cantResendCode:
			'No podemos reenviar el código ahora. Por favor inténtalo de nuevo en unos minutos.',
		enterCurrentPassword: 'Ingresa tu contraseña actual',
		enterNewPassword: 'Ingresa tu nueva contraseña',
		enterConfirmNewPassword: 'Confirma tu nueva contraseña',
		passwordUpdated: '¡Tu contraseña fue actualizada éxitosamente!',
		successful2Factor:
			'¡Tu autenticación de factor doble se ha completado éxitosamente!',
		areYouSure:
			'¿Estas seguro que quieres deshabilitar la autenticación de factor doble?',
	},

	//Contact
	contact: {
		requestCall: 'Solicitar una llamada',
		phoneNumber: 'Número de teléfono',
		preferedTime: 'Hora',
		selectPreferedTime: 'Selecciona el momento en que quieres que te llamemos',
		enterPhone: 'Ingresa tu número de teléfono ',
		knowMore: 'Conoce más acerca de nosotros',
		callSchedule: 'Tu llamada está agendada',
		callScheduleDescription:
			'Nos pondremos en contacto contigo lo más pronto posible. Por favor, ten en cuenta que esta llamada puede ocurrir dentro de las 24 horas después de tu solicitud, empezando el día hábil siguiente.',
		failedToSchedule: 'No fue posible agendar tu llamada',
		contactUsErrorCall:
			'Nos disculpamos por el inconveniente. Por favor, inténtalo de nuevo, si el problema continúa, puedes usar cualquier otra opción disponible para contactarnos.',
		weWillContactYou:
			'Uno de nuestros agentes se pondrá en contacto contigo en la fecha y hora que seleccionaste: ',
		unableToContactYou:
			'Lastimosamente no pudimos agendar tu llamada. Por favor, revisa la información que seleccionaste e intenta de nuevo. ',
		infoInvalid:
			'La información que proporcionaste no es válida. Por favor, revisa e intenta de nuevo. ',
		inNeedOfHelp: '¿Necesitas ayuda? ¡Aquí estamos para ayudarte!',
		inNeedOfHelpDescription:
			'Desde solicitar más información acerca de tus requerimientos, hasta confirmar los detalles de tu cuenta ¡estamos disponibles para ayudarte! Ponte en contacto con nosotros:',
		chatDescription:
			'¿Te sientes más cómodo por chat? ¡Estamos a un chat de distancia!',
		chatDescription1:
			'Nuestros agentes están disponibles las 24 horas del día durante los días hábiles de EE.UU. ',
		mailForward:
			'¿No es tan urgente? Envíanos un correo electrónico con tus preguntas o inquietudes y te responderemos lo más pronto posible. ',
		emailUs: 'Envíanos un correo electrónico',
		letsChat: 'Chateemos',
		scheduleACall: 'Programar una llamada',
		contactDisclaimer:
			'Si lo prefieres, puedes contactarnos directamente a nuestro telefono',
		orVia: 'o por correo electrónico a ',
		contactDisclaimerLatam:
			'Si lo prefiere, puede contactarnos directamente al siguiente correo electrónico',
		stayConnected: 'Manténte conectado con nosotros',
		timeZone: 'Zona horaria',
		selectTimeZone: 'Selecciona tu zona horaria',
		customDate: 'Quiero seleccionar una fecha y hora específica',
		soonAsPossible: 'Lo más pronto posible',
		callWhen: '¿Cuándo podemos llamarte?',
		contactHelper:
			"Por favor, ten en cuenta: Nuestras llamadas programadas se realizan exclusivamente en inglés. Si eliges la opción 'Lo antes posible', nos pondremos en contacto contigo dentro de las 24 horas del siguiente día hábil.",
		selectDate: 'Selecciona la fecha',
		selectTime: 'Selecciona la hora',
		selectOption: 'Selecciona una opción',
		preferredDate: 'Fecha',
		sendEmail: 'Enviar un correo ',
		subject: 'Asunto',
		describeEmail: 'Describe el propósito de tu mensaje',
		concerns: 'Escribe tus preguntas, preocupaciones o comentarios aquí. ',
		yourMessage: 'Tu mensaje',
		emailSuccessful:
			'¡Tu correo electrónico fue enviado éxitosamente! Te daremos respuesta tan pronto sea posible.',
		emailSuccessfulTitle: 'Correo electrónico recibido',
		emailErrorfulTitle: 'Problemas con tu correo electrónico',
		emailErrorMessage:
			'Nos disculpamos por el inconveniente. Por favor, inténtalo de nuevo, si el problema continúa, puedes usar cualquier otra opción disponible para contactarnos.',
		japanNotice:
			'Para la zona horaria estándar de Japón, las llamadas están disponibles únicamente en el rango de 10:00 PM y 12:00 AM o a las 6:00 AM. Nos disculpamos de antemano por el inconveniente. ',
		messageError: 'El mensaje no puede superar los 900 caracteres',
		messageErrorShort: 'El mensaje debe contener al menos 15 caracteres',
		titleError: 'El asunto no puede superar los 60 caracteres',
		titleErrorShort: 'El asunto debe contener al menos 4 caracteres',
		preferredDate: 'Fecha',
		failedAttempt: 'Por favor, intenta mas tarde',
		callDate: 'Tu llamada está agendada',
		contactSetDate:
			'Uno de nuestros agentes se pondrá en contacto contigo en la fecha y hora que seleccionaste:',
		errorPhoneNumber:
			'El número de teléfono no puede contener letras ni símbolos',
		callDescription:
			'¿Quieres hablar con uno de nuestros agentes? respetamos tu tiempo, agenda el horario más conveniente para ti.',
		changePasswordDescription:
			'Gestiona tus suscripciones, cambia la configuración y protege la seguridad de tu cuenta.',
		errorCantNumber:
			'El número de celular que ingreses debe tener entre 7 y 15 dígitos.',
	},

	//menu
	menu: {
		appli: 'Aplicaciones',
		account: 'Cuentas',
		platforms: 'Centro de descarga',
		history: 'Actividad',
		deposit: 'Depósito',
		transfer: 'Transferir',
		withdraw: 'Retirar',
		tradingTools: 'Herramientas de trading',
		settings: 'Configuración',
		passwordsettings: 'Configuración de contraseña',
		emailsettings: 'Configuración de correo electrónico',
		authenticationsettings: 'Configuración de autenticación',
		contactUs: 'Ayuda',
		accessDemo: 'Acceder a la cuenta demo',
		accessRestricted: 'Acceso restringido',
		btnReSubmit: 'Reenviar documento',
		temporarilyUnavailable:
			'Estas funciones no están disponibles temporalmente',
		sorryFeature:
			'Lo sentimos, pero las funciones que estás intentando acceder aún no están disponibles. Una vez que completes tu proceso de aplicación y tu cuenta esté configurada, podrás acceder a ellas.',
		btnContinue: 'Continuar',
		liveFeature: 'Estas son funciones de cuenta en vivo',
		featureOnly:
			'Las funciones que estás intentando acceder solo están disponibles para cuentas en vivo. Crea una cuenta en vivo ahora para obtener acceso.',
		call: '¿No tienes tiempo que perder? Nuestro equipo de soporte está a una llamada telefónica de distancia, 24/5 GMT.',
		chat: '¿Prefieres chatear? Vamos a hacerlo. Nuestros agentes están disponibles 24/7 en los días laborales de EE. UU.',
		mail: '¿No es tan urgente? Envíanos un correo electrónico, nuestros expertos te responderán.',
		call2: 'Llámanos',
		chat2: 'Chatea con nosotros',
	},

	//sidebar applications process
	sidebar: {
		help: '¿Necesitas ayuda?',
		call: 'Llámanos',
		chat: 'Chatea con nosotros',
		mail: 'Envíanos un correo',
		notReady: '¿No estás listo para una cuenta Live?',
		btnDemo: 'Crea una cuenta demo',
	},

	//form signature
	formSignature: {
		authorised: 'Firma del cliente autorizado, firma arriba',
		or: 'O',
		accept: 'Confirmar firma',
		error1: 'No has firmado, por favor, hazlo.',
		drop: 'Arrastra tus archivos aquí o',
		browse: 'navega',
		make: 'Asegúrate de que el archivo esté en formato JPEG, PNG o PDF y que su tamaño no supere los 2 MB',
		error_help: 'No has subido un archivo con tu firma, por favor hazlo.',
	},

	//Text of application process form
	applicationForm: {
		duplicateShareholder: 'Ya existe un accionista con este nombre y apellido.',
		duplicateEmail: 'A shareholder with this email already exists.',
		details: 'Detalles',
		idVerification: 'Verificación de identidad',
		proofResidence: 'Comprobante de domicilio',
		proofResidenceConsent: 'Comprobante de domicilio y consentimiento',
		consent: 'Consent',
		liveIndividual: 'Cuenta individual Live',
		liveJointAccount: 'Cuenta conjunta Live',
		primaryAccountHolder: 'Titular pincipal de la cuenta',
		title: 'Datos personales',
		subtitlePlatform:
			'Después de crear tu primera cuenta en Tradeview, puedes abrir más cuentas para otros activos financieros sin necesidad de llenar todo el formulario nuevamente',
		subtitleDocument:
			'Confirmar tu identidad con un documento de identificación emitido por el gobierno garantiza la seguridad y legitimidad de tu cuenta.',
		subtitleResidence:
			'Confirma tu ubicación para garantizar el cumplimiento de los estándares regulatorios.',
		subtitleExperience:
			'Selecciona la opción que mejor represente tu experiencia operando en Forex, acciones, futuros o CFDs.',
		submitContact: 'contactarnos',
		drop: 'Arrastra tus archivos aquí o',
		browse: 'haz clic para buscarlo en tu dispositivo',
		make: 'Asegúrate de que el archivo esté en formato JPEG, PNG o PDF y que su tamaño no supere los 2 MB.',
		makeMaxSize:
			'Asegúrate de que el archivo esté en formato JPEG, PNG o PDF y que su tamaño no supere los 15 MB.',
		tryAgain: 'Intenta de nuevo',
		openFile: 'Abrir Archivo',
		submitted: 'Solicitud enviada: Revisión en progreso',
		thankyou:
			'Gracias por enviar tu solicitud de cuenta. Tu solicitud está ahora en revisión y será verificada en breve.',
		operations:
			'Nuestro equipo de operaciones se pondrá en contacto contigo si se requiere alguna documentación adicional.',
		appreciate:
			'Agradecemos tu cooperación y te mantendremos informado/a sobre el progreso.',
		gotocabinet: 'Ir a mi panel',
		explore: 'Explorar Tradeview',
		acknowledgementText:
			'Al firmar a continuación, reconozco y acepto los documentos enumerados en el paso anterior de este proceso.',
		acknowledgementTextLATAM:
			'Revisa cuidadosamente cada elemento de esta página antes de marcar las casillas y firmar.',
		jointConsent:
			'Revisa y comprende cuidadosamente cada elemento de esta página antes de marcar las casillas de aceptación y firmar.',
		secondaryAccount: 'Cotitular de la cuenta',
		secondaryAccountDesc:
			'Para finalizar la configuración de tu cuenta es necesario que nos proporciones información general del cotitular de la cuenta. ',
		primaryAccountHolder: 'Titular principal de la cuenta (tú): ',
		secondaryAccountHolder: 'Cotitular de la cuenta',
		corporateResol: 'Resolución corporativa',
		corporateResolDisclaimer:
			'Para subir el archivo, arrástralo al campo o haz clic en el icono para buscarlo en tu dispositivo.',
		corporateResolDisclaimer2:
			'Asegúrate de que el archivo esté en formato JPEG, PNG o PDF y que su tamaño no supere los 2 MB.',
		corporateResolDesc:
			'Puedes descargar y completar la resolución corporativa estándar de Tradeview haciendo clic en {link}, o puedes proporcionar la tuya propia.',
		shareHolder: 'Adición de accionistas',
		shareHolderDesc:
			'Agrega hasta 9 accionistas. Cada uno debe ser asignado con al menos 10% de participación, también puedes saltar este paso para solicitar una cuenta corporativa sin socios accionistas.',
		addShareholder: 'Agregar nuevo accionista',
		or: 'o',
		completeShareholder: 'Completa los datos del accionista',
		shareholder: 'Accionista',
		information: 'Información',
		aboutToComplete:
			'Estás a punto de completar la información del accionista #{number}',
		noShareAvailable:
			'El porcentaje combinado de los accionistas y del titular de la cuenta no puede superar el 100%. Inténtalo de nuevo.',
		percentageLow:
			'El porcentaje combinado de los accionistas y del titular de la cuenta debe ser del 100%. Por favor, verifica.',
		aboutToCompleteDesc:
			'Antes de comenzar, prepara los siguientes documentos del accionista #{number}:',
		accountHolderDisclaimer:
			'Para los accionistas que posean más del {percentage} de la empresa, requerimos información personal, identificación y comprobante de domicilio. Para los accionistas con menos del {percentage} de participación, solo solicitamos su nombre y apellido.',
		deleteShareholder:
			'Para editar las acciones o cargar la identificación y comprobante de domicilio de un accionista, debes eliminar la entrada existente y agregarla nuevamente.',
		sendInvitation: 'Enviar invitación',
		pendingShareholderTitle: 'Falta información del accionista',
		pendingShareholderDesc:
			'Falta información de los accionistas. Para continuar, por favor proporciona la información requerida de cada accionista.',
		inviteSentSuccess: 'La invitación se envió con éxito',
		inviteSentSuccessDesc:
			'Sigue el progreso de la solicitud de cada accionista en la sección de Información del Accionista.',
		primaryHolder: 'Titular principal de la cuenta (tú): ',
		sharePercent:
			'"El porcentaje de participación accionaria representa la propiedad de la empresa. Asigna porcentajes a los accionistas para definir su participación en la estructura corporativa. Es importante recordar que el porcentaje de participación que asignes debe ser un número entre 0 y 100, y la suma total de los porcentajes de participación de los accionistas no debe exceder el 100%."',
		accountHolder: 'Titular principal de la cuenta (tú): ',
		shareHolderDetails: 'Detalles del accionista',
		continueNoShareholder: 'Continuar',
		infoSwitchOff:
			'Si es requerido por jurisdicción, nuestro equipo se contactará contigo para solicitarlo.',
		fileNotValid: 'Por favor, sube un archivo en un formato y tamaño válido.',
		resolUpload:
			'Asegúrate de que la información e imágenes en tus archivos sean claras y comprensibles. </br></br> Puedes subir los documentos que tengas en este momento. Si faltan algunos, ¡No te preocupes! de ser solicitados, puedes subirlos o enviarlos más tarde por correo electrónico.',
		upDocument: 'Carga de documentos',
	},
	expiredDocument: {
		resubmit: 'Vuelve a enviar tus documentos',
		settingsDesc:
			'Actualiza tus documentos de identificación y/o comprobante de domicilio reenviándolos aquí para seguir operando sin interrupciones.',
		resubmitDesc:
			'Tu(s) documento(s) de verificación han expirado. Por favor, carga un nuevo archivo ahora o dentro de los próximos {days} días en la configuración de tu gabinete. Si no lo haces, no podrás transferir, retirar ni depositar hasta que esté actualizado.',
		idRefinitiv: '¿Qué método de verificación de ID te gustaría usar?',
		idRefinitivDesc:
			'Actualizar tu identidad con un documento de identificación emitido por el gobierno garantiza la seguridad y legitimidad de tu cuenta.',
		idTooltip:
			'Elige cómo te gustaría completar tu verificación de ID. Puedes escanear el código QR con tu teléfono o abrir una nueva pestaña en tu computadora. Selecciona tu método preferido a continuación.',
		cancelModal: '¿Estás seguro de que deseas salir?',
		cancelModalDesc:
			'Por favor recuerda que debes completar este paso en los próximos {days} días. Si no lo haces, no tendrás acceso a las funcionalidades de retiro, depósito y transferencia en tu gabinete hasta que los documentos requeridos sean actualizados.',
		accessRestricted: 'Acceso restringido',
		uploadDocs: 'Sube tu(s) documento(s)',
		resubmitDocs: 'Vuelve a cargar los documentos',
		restrictedID:
			'Notamos durante una verificación aleatoria que tu identificación proporcionada ha expirado. Para garantizar la seguridad de tu cuenta, hemos bloqueado temporalmente las funcionalidades de transferencia, retiro y depósito.',
		restrictedID2:
			'Por favor, carga una nueva identificación ahora para restaurar el acceso y continuar disfrutando de una experiencia sin interrupciones en tu gabinete.',
		restrictedPOA:
			'Notamos durante una verificación aleatoria que tu comprobante de domicilio proporcionado ha expirado. Para garantizar la seguridad de tu cuenta, hemos bloqueado temporalmente las funcionalidades de transferencia, retiro y depósito.',
		restrictedPOA2:
			'Por favor, carga un nuevo comprobante de domicilio ahora para restaurar el acceso y continuar disfrutando de una experiencia sin interrupciones en tu gabinete.',
		restrictedBoth:
			'Notamos durante una verificación aleatoria que tanto tu identificación como tu comprobante de domicilio han expirado. Para garantizar la seguridad de tu cuenta, hemos bloqueado temporalmente las funcionalidades de transferencia, retiro y depósito.',
		restrictedBoth2:
			'Por favor, carga nuevos archivos ahora para restaurar el acceso y continuar disfrutando de una experiencia sin interrupciones en tu gabinete.',
		restrictedLimited:
			'Faltan tus documentos de verificación. Por favor, súbelos para obtener acceso; hasta entonces, tu cuenta de trading permanecerá restringida.',
		confirmationLimited:
			'Recuerda completar este paso. De lo contrario, tu cuenta de trading permanecerá deshabilitada hasta que subas tus documentos.',
		alertExpiredDocsSuccess:
			'Has enviado tu documento con éxito. Ahora está en revisión. Si se requiere documentación adicional, nuestro equipo se pondrá en contacto contigo.',
		alertExpiredDocsError:
			'Por favor, sube nuevos documentos ahora o dentro de los próximos {days} días.',
		alertMissingDocsError:
			'Sube tus documentos para habilitar tu cuenta de trading.',
		submitDoc: 'Enviar documento(s)',
		idverseD:
			'Este proceso es esencial para prevenir el fraude y asegurar el uso responsable y legal de nuestros servicios. Agradecemos tu cooperación.',
		idverseT:
			'Elige cómo quieres completar tu verificación de ID: escanea el código QR con tu celular, recibe un SMS con el enlace o continúa en tu dispositivo actual.',
	},

	//Aplication Process refinitiv
	appliProcessIDverse: {
		QRdescription: 'Usa la cámara de tu teléfono para escanear el código QR.',
		IDVerseTitle: '¿Qué método de verificación de identidad deseas usar?',
		IDVerseTitleLatam: 'Elige tu método de verificación de identidad preferido',
		IDVerseTitleManualDoc:
			'Elige tu método de verificación de identidad preferido',
		IDVerseTitleManualDocTitle: 'Elige un tipo de documento',
		IDVerseTitleManualDocDesc:
			'Por favor, selecciona el tipo de documento que deseas usar para la verificación:',
		IDVerseTitleManualDocMainDesc:
			'El proceso de verificación de identidad es esencial para prevenir fraudes y garantizar el uso responsable y legal de nuestros servicios. Agradecemos sinceramente tu cooperación.',
		IDVerseDesc:
			'Para una experiencia más fluida, te sugerimos completar este paso en tu teléfono usando una de las siguientes opciones:',
		or: 'o',
		verifyOnNewTab: 'Verifica tu identidad en una nueva pestaña.',
		sendLinkSms: 'Enviar enlace por SMS',
		verifyPopupConfig:
			'Por favor, asegúrate de que el bloqueador de ventanas emergentes de tu navegador esté desactivado. Para más información,',
		clickHere: 'clic aquí',
		alertDetail:
			'Ten en cuenta que solo puedes acceder al proceso de verificación una vez por enlace único. Si necesitas acceder de nuevo, actualiza tu página y luego presiona tu método de verificación preferido.',
		alertDetailMobile:
			'Ten en cuenta que solo puedes acceder al proceso de verificación una vez por enlace único. Para completar el proceso de verificación, actualiza tu página y luego presiona `Verificar mi ID`. Si ya lo completaste, presiona Continuar.',

		//Modal Verify Identity
		modalVerifyTitle: 'Verifica tu identidad.',
		btnVerifyID: 'Verificar mi identidad',
		modalVerifyDesc1:
			'Para continuar, debes completar el proceso de verificación de identidad.',
		modalVerifyDesc2:
			'Si ya lo has completado y aún no puedes continuar, por favor contáctanos lo antes posible.',
		modalVerifyButton: 'Selecciona tu método de verificación de identidad',
		//Skip step
		modalSkipTitle: '¿Está seguro de que quieres omitir este paso?',
		modalSkipDesc1:
			'Puedes omitir este paso temporalmente y completarlo más adelante en tu gabinete de cliente, o elegir un método de verificación de identidad ahora para finalizar el proceso.',
		modalSkipDesc2:
			'Por favor ten en cuenta que completar este paso es necesario para activar tu cuenta de trading.',
		btnVerifyAddress: 'Verificar mi dirección',
		btnVerifyIdentity: 'Verificar mi identidad',
		btnSkip: 'Omitir por ahora',
		modalSendSMSChangeNumberTitle: 'Ingresa un nuevo número de móvil',
		modalSendSMSChangeNumberDesc:
			'Ingresa el número móvil donde deseas recibir el enlace de verificación por SMS.',
		modalSendSMSChangeNumberButton: 'Enviar',
		modalSendSMSChangeNumberCancel: 'Cancelar',
		modalSendSMSChangeNumberCheck: 'Guardar como mi número móvil registrado.',
		modalSendLinkSMSFailedTitle: 'Ocurrió un error',
		modalSendLinkSMSFailedDesc:
			'No pudimos enviar el enlace por SMS. Verifica el número e intenta nuevamente.',
		modalSendLinkSMSFailedButtonCancel: 'Cancelar',
		modalSendLinkSMSFailedButtonChangeNumber: 'Cambiar número',
		modalSendLinkSMSTitle: 'Enlace enviado por SMS',
		modalSendLinkSMSDesc:
			'Se ha enviado un enlace a tu número móvil registrado por SMS. Abre el enlace en tu teléfono y sigue los pasos para completar la verificación de identidad.',
		modalSendLinkSMSButtonReSend: 'Reenviar',
		modalSendLinkSMSButtonOkay: 'Aceptar',
		clickHere: 'Haz clic aquí',
		or: 'O',
		modalSendLinkSMSOptionalNumber: 'Enviar a otro número móvil',
		uploadCurrentDevice: 'para subir tu documento desde tu dispositivo actual.',
		retryIn: 'intenta nuevamente en',
		chooseTooltip:
			'Elige cómo deseas completar la verificación de identidad. Puedes escanear el código QR con tu teléfono, enviar un enlace por SMS o continuar en tu dispositivo actual.',
		sendToDifferentNumber: 'Enviar a otro número móvil',
		chromeInstructions: {
			step1: 'Ve a Configuración',
			step2:
				'Navega a Privacidad y seguridad > Configuración del sitio > Ventanas emergentes y redirecciones',
			step3: "Desactiva la opción 'Bloquear'",
		},
		safariInstructions: {
			step1: 'Ve a Safari > Preferencias',
			step2: 'Selecciona Sitios web > Ventanas emergentes',
			step3: 'Ajusta la configuración según sea necesario.',
		},
		firefoxInstructions: {
			step1: 'Haz clic en el ícono del menú.',
			step2: 'Ve a Preferencias > Privacidad y seguridad > Permisos.',
			step3:
				'Ajusta la configuración de ventanas emergentes según sea necesario.',
		},
		assistanceText: `Si encuentras alguna dificultad, por favor`,
		assistanceText2: `contáctanos para recibir asistencia.`,
	},

	//Application process CORPORATE form
	applicationFormCorporate: {
		liveCorporateAccount: 'Cuenta corporativa Live',

		//Company details
		companyDetailsTitle: 'Detalles de la empresa',
		nameLabel: 'Nombre de la empresa',
		namePlaceholder: 'Ingresa el nombre de la empresa',
		businessTypeLabel: 'Tipo de negocio',
		businessTypePlaceholder: 'Selecciona el tipo de negocio',
		companyEmailLabel: 'Correo electrónico empresarial',
		companyEmailPlaceholder: 'Ingresa un correo electrónico de la empresa',
		companyEmailTooltip:
			'Pedimos un correo electrónico empresarial para garantizar una comunicación segura y verificar la legitimidad de tu cuenta corporativa. Esto contribuye a mantener un entorno de trading seguro y confiable para tu empresa.',
		businessDescriptionLabel: 'Descripción del negocio',
		businessDescriptionPlaceholder:
			'Ingresa una breve descripción del tamaño de tu empresa y los servicios que ofrece',
		businessDescriptionTooltip:
			'Esta información nos ayuda a comprender las actividades y el propósito de tu empresa. Con una compresión de la actividad de tu empresa, podemos adaptar nuestros servicios para satisfacer las necesidades de tu negocio.',

		//Company address
		companyAddressTitle: 'Dirección de la empresa',
		companyAddressTitleTooltip: `Esta información nos ayuda a comprender la jurisdicción legal de tu negocio y garantizar el cumplimiento de las regulaciones regionales.  </br> </br< Si el país en el que está registrada tu empresa no está listado entre las opciones, lamentamos informarte que no podemos ofrecer nuestros servicios en está ubicación. `,

		//Account ownership
		accountOwnershipTitle: 'Información de propiedad de la cuenta',
		dateIncorporationLabel: 'Fecha de constitución de la empresa',
		dateIncorporationTooltip:
			'La fecha en que la empresa fue oficialmente registrada. Esta información nos ayuda a verificar el estado legal de tu negocio y garantizar el cumplimiento de los requisitos regulatorios.',
		countryOfRegistrationLabel: 'País de constitución de la empresa',
		countryOfRegistrationPlaceholder: 'Selecciona un país',
		countryOfRegistrationTooltip:
			'El país en el que la empresa está oficialmente registrada. Esta información nos ayuda a comprender la jurisdicción legal de tu negocio y garantizar el cumplimiento de las regulaciones regionales.',
		marketCapitalizationLabel:
			'Capitalización total del mercado o patrimonio neto',
		marketCapitalizationPlaceholder:
			'Ingresa la capitalización total del mercado de tu empresa',
		marketCapitalizationTooltip:
			'La capitalización total de mercado es el valor de mercado general de las acciones pendientes de una empresa, mientras que el patrimonio neto representa el valor total de los activos de una empresa después de restar sus pasivos.',
		isSubsidiaryLabel:
			'Si la empresa es una subsidiaria, ingresa el nombre de la empresa matriz.',
		isSubsidiaryPlaceholder: 'Ingresa el nombre de la empresa matriz',
		isIndividualRegularMemberLabel:
			'¿La persona que está completando este formulario es un miembro/socio, o representa a los dueños beneficiarios de la entidad mencionada en esta relación?',

		//Tax residency information
		taxResidencyTitle: 'Declaración de residencia fiscal',
		isUSCompanyLabel:
			'¿La empresa se considera una entidad o un residente fiscal de EE.UU.?',
		taxResidencyContryLabel:
			'Por este medio la empresa confirma que, a efectos fiscales, es residente del siguiente país:',
		taxResidencyContryListLabel: 'País ',
		taxResidencyContryListPlaceholder: 'Selecciona un país',
		taxResidencyReferenceCodeLabel: 'Número de referencia fiscal',
		taxResidencyReferenceCodePlaceholder:
			'Ingresa tu número de referencia fiscal',
		modalRegulationP:
			'Lamentamos informarte que, debido a las regulaciones, no podemos ofrecer servicios a personas que residen en el territorio de los Estados Unidos. Gracias por tu interés en unirte a Tradeview.',

		//Account type and platform information
		accountTypeTitle: 'Tipo de cuenta',

		// Financial details
		financialDetailsTitle: 'Detalles financieros',
		financialDetailsTooltip:
			'Para garantizar una evaluación asertada de los riesgos para tu empresa y para Tradeview, necesitamos información detallada sobre las finanzas de tu empresa.',
		companyAnnualIncomeLabel:
			'¿Cuál es el ingreso anual o volumen de negocios total de tu empresa?',
		companyAnnualIncomeTooltip:
			'La renta anual o facturación total de una empresa se refiere al ingreso total generado por la organización durante un período específico de tiempo (generalmente un año).',
		companyTotalAssetsLabel:
			'¿Cuál es el balance total de los activos de tu empresa?',
		companyTotalAssetsTooltip:
			'El balance de activos de tu empresa es el valor de sus ahorros, inversiones y propiedades de bienes raices, después de deducir los compromisos. ',
		companyLiquidAssetsLabel:
			'¿Cuál es el balance de activos líquidos de tu empresa?',
		companyLiquidAssetsTooltip:
			'El balance de activos líquidos es la suma de dinero en efectivo, instrumentos de mercado monetario y valores negociables de tu empresa. ',
		companyOriginAssetsLabel:
			'¿Cuál es el origen de los activos totales de tu empresa?',
		companySourceFundsLabel:
			'¿Cuál es la fuente de los depositos/fondos de tu empresa? ',
		companyPruoseAccountLabel:
			'¿Cuál es el propósito principal de esta cuenta?',
		companyIsConnectedBanktruptcies:
			'¿La empresa tiene alguna afiliación a bancarrotas?',
		companyIsConnectedBanktruptciesDetailsLabel: 'Detalles de la bancarrota',
		companyIsConnectedBanktruptciesDetailsPlaceholder:
			'Agrega información sobre la(s) bancarrota(s) con la(s) que está vinculada la empresa.',
		companyIsConnectedBanktruptciesDetailsTooltip:
			'La compañía está obligada a revelar cualquier afiliación de bancarrota para abordar los riesgos para ambas partes (la compañía y Tradeview). Sin embargo, tenga la seguridad de que si la compañía tiene alguna conexión con la bancarrota, aún es bienvenido continuar con el proceso de solicitud.',

		//Proof of address
		proofAddressTitle: 'Comprobante de domicilio',
		proofAddressTitleCorporate: 'Comprobante de domicilio de la empresa',
		proofAddressDescription:
			'Confirma la ubicación de tu empresa para garantizar el cumplimiento de los estándares regulatorios. ',

		//Company Account Consent
		companyAccountConsentTitle:
			'Gracias por compartir los detalles de tu empresa con nosotros. ¡Sigamos adelante con el proceso!',
		companyAccountConsentDescription1:
			'Ahora, llena la información del titular de la cuenta. Puedes editar la información proporcionada en cualquier momento desde la lista de progreso en el lado derecho de la pantalla. Solo haz clic en el ícono de lápiz junto a la información que desees modificar.',
		companyAccountConsentDescription2:
			'Por favor, ten en cuenta que, además de los documentos de identificación emitidos por el gobierno y el comprobante de domicilio, puedes cargar los documentos a tu conveniencia, ya sea ahora o más tarde cuando se te soliciten.',
		companyAccountConsentDocumentsTitle:
			'Antes de iniciar, prepara los siguientes documentos:',
		companyAccountConsentDocumentsList1:
			'Documento de identificación del titular de la cuenta, emitido por el gobierno (debe incluir fotografía):',
		companyAccountConsentDocumentsList2:
			'Comprobante de domicilio del titular de la cuenta',
		applicationFormAccountCheck:
			'*Consiento que Tradeview Ltd. verifique electrónicamente mi identidad utilizando la información y los documentos proporcionados. Esta verificación será realizada por un proveedor de servicios de verificación de identidad de confianza para garantizar la precisión de los datos.',

		//Company Consent
		companyConsentTitle: '¡Gracias por tu interés! Empecemos con tu aplicación',
		companyConsentDescription:
			'Para configurar tu cuenta corporativa, necesitamos información de tu parte.',
		companyConsentDocumentsTitle:
			'Antes de iniciar, prepara los siguientes documentos:',
		companyConsentDocumentsOfCompanyTitle: 'Empresa',
		companyConsentDocumentsList1: 'Certificado de registro de la empresa',
		companyConsentDocumentsList2: 'Comprobante de domicilio de la empresa',
		companyConsentDocumentsList3: 'Estado bancario de la empresa',
		companyConsentDocumentsList4: 'Estado financiero de la empresa',
		companyConsentDocumentsList5: 'Certificado fiscal de la empresa',
		companyConsentDocumentsList6: 'Estructura de propiedad de la empresa',
		companyConsentDocumentsList7: 'Reporte anual empresarial',
		companyConsentDocumentsOfAccountHolderTitle: 'Titular de la cuenta:',
		companyConsentDocumentsOfAccountHolderList1:
			'Plan de negocios de la empresa',
		companyConsentDocumentsOfAccountHolderList2:
			'Licencia de negocio de la empresa',
		companyConsentDocumentsOfShareholderTitle:
			'Beneficiario Final/ Accionistas:',
		companyConsentDocumentsOfShareholderList1:
			'Acuerdo de accionistas de la empresa',
		companyConsentDocumentsOfShareholderList2:
			'Certificado de accionistas de la empresa',
		companyConsentAdditionalInfoDescription:
			'Para enviar tu solicitud, solo necesitas cargar tu comprobante de domicilio e identificación. Los demás documentos puedes cargarlos ahora o enviarlos por correo electrónico más adelante, ¡tú decides!',
		applicationFormConsentCheck:
			'Consiento que Tradeview Ltd. verifique electrónicamente mi identidad utilizando la información y los documentos proporcionados. Esta verificación será realizada por un proveedor de servicios de verificación de identidad de confianza para garantizar la precisión de los datos.',

		//Account holder details
		accountHolderDetailsTitle: 'Información del titular de la cuenta',
		accountHolderDetailsTooltip:
			'El titular de la cuenta es el principal responsable de administrar la cuenta corporativa. Esta persona será responsable de operar la cuenta, tomar decisiones financieras clave y tiene la autoridad para agregar o eliminar accionistas. Es crucial que los detalles del titular de la cuenta representen asertivamente al individuo que toma las decisiones corporativas en tu empresa.',

		//Account holder address
		accountHolderAddressTitle: 'Dirección del titular de la cuenta',
		accountHolderAddressTooltip:
			'Proporciona la dirección residencial o empresarial del titular de la cuenta. Esta información debe corresponder al individuo titular de la cuenta corporativa, y no a la empresa en sí misma.',

		//Account holder tax residency declaration
		accountHolderTaxResidencyTooltip:
			'Proporciona la dirección residencial o empresarial del titular de la cuenta. Esta información debe corresponder al individuo titular de la cuenta corporativa, y no a la empresa en sí misma.',
		accountHolderTaxResidencyModalDescription:
			'Lamentamos informarte que, debido a las regulaciones, no podemos ofrecer servicios a personas que residen en el territorio de los Estados Unidos. Gracias por tu interés en unirte a Tradeview.',

		//Account holder trading experience
		accountHolderTradingExperienceDescription:
			'Selecciona las opciones que mejor representen tu experiencia en trading de Forex, Stocks, Futuros, Derivados o CFDs.',

		//Shareholder consent
		shareholderConsentTitle:
			'¡Excelente! La información del titular de la cuenta ahora está completa. ¡No pierdas el impulso!',
		shareholderConsentDescription1:
			'Casi hemos terminado. Solo hace falta la información de los accionistas.',
		shareholderConsentDescription2:
			'Recuerda que, de ser necesario, puedes editar la información en cualquier momento desde la lista de progreso en el lado derecho de la pantalla. Solo haz clic en el ícono de lápiz junto a la información que desees modificar.',
		shareholderConsentDescription3:
			'Ten en cuenta que, aparte de los documentos de identificación con foto emitidos por el gobierno y el comprobante de domicilio, puedes cargar los demás documentos necesarios en cualquier momento, ya sea ahora o más tarde.',
		companyConsentConsentDocumentsTitle:
			'Antes de comenzar, por favor asegúrese de que usted o los accionistas tengan los siguientes documentos obligatorios listos:',
		companyConsentConsentDescription1:
			'¡Ya casi terminamos! Solo ingrese la información de los accionistas para completar el proceso.',
		companyConsentConsentDescription2:
			'Si es necesario, puede editar cualquier detalle que haya ingresado previamente haciendo clic en el ícono de lápiz en la columna derecha.',
		shareholderConsentDocumentsTitle:
			'Antes de iniciar, cada accionista deberá estar preparado con los siguientes documentos:',
		shareholderConsentDocumentsList1:
			'Documento de identificación del accionista, emitido por el gobierno (debe incluir fotografía):',
		shareholderConsentDocumentsList2: 'Comprobante de domicilio del accionista',
		shareholderConsentDocumentsList3: 'Firma digital',
		shareholderConsentCheck:
			'*Consiento que Tradeview Ltd. verifique electrónicamente mi identidad y la de mi empresa utilizando la información y los documentos proporcionados. Esta verificación será realizada por un proveedor de servicios de verificación de identidad de confianza para garantizar la precisión de los datos.',

		//Application Submition
		applicationSubmitionTitle: 'Envio de solicitud',
		applicationSubmitionDescription1:
			'¡Ya casi terminas! Valoramos el esfuerzo realizado al completar esta solicitud. ',
		applicationSubmitedTitle:
			'Solicitud de cuenta corporativa enviada: En proceso de revisión',
		applicationSubmitedDescription1:
			'Gracias por enviar la solicitud de tu cuenta corporativa. Ahora está bajo revisión y será verificada pronto. ',
		applicationSubmitedDescription2:
			'Nuestro equipo se pondrá en contacto contigo si necesitamos más documentación. Agradecemos tu cooperación y te mantendremos informado sobre el progreso.',

		//Global
		selectOption: 'Selecciona una opción',
		accountOwnershipTooltip:
			'Esta información nos ayuda a comprender la jurisdicción legal de tu negocio y garantizar el cumplimiento de las regulaciones regionales. Si el país en el que está registrada tu empresa no está listado entre las opciones, lamentamos informarte que no podemos ofrecer nuestros servicios en está ubicación. ',

		//Progress
		companyInformation: 'Información de la empresa',
		companyAddressDetails: 'Detalles de la dirección de la empresa',
		companyOwnershipDetails: 'Detalles de propiedad de la empresa',
		companyDocuments: 'Documentos de la empresa',
		accountConsent: 'Consentimiento de la cuenta',
		accountConsentCorporate: 'Información del titular de la cuenta',
		tradingExperience: 'Experiencia de trading',
		accountInformation: 'Información de tu cuenta',
		tradingExperience: 'Experiencia de trading',
		IDVerification: 'Verificación de identidad',
		accSetupSubmision: 'Configuración y envío de la cuenta',
		shareholderInformation: 'Información para accionistas',
		shareholderConsent: 'Consentimiento de los accionistas',
		finish: 'Finalizar',

		addressDetails: 'Detalles de la dirección',

		share: 'Porcentaje',

		//Shareholder consent
		welcomeShareholderConsentTitle:
			'¿Listo para unirte a tu cuenta corporativa? Comencemos tu solicitud',
		welcomeShareholderConsentDescription1:
			'Para configurar tu cuenta corporativa, necesitamos algo de información de tu parte.',
		shareholderConsentDocumentsTitle:
			'Antes de comenzar, prepara los siguientes documentos:',
		welcomeShareholderConsentDocumentsList1:
			'Identificación con foto emitida por el gobierno',
		welcomeShareholderConsentDocumentsList2: 'Comprobante de residencia',
	},

	//disclaimer
	disclaimer: {
		title: 'Aviso legal',
		secure1: 'SEGURA ',
		secure2: 'ENCRIPTACIÓN SSL ',
		secure3: '',
		es: {
			description:
				'La oferta de servicios y productos por parte de Tradeview Ltd. no está disponible en los Estados Unidos (EE. UU.) y no están dirigidos a personas residentes de los EE. UU., según se define en la ley de este país. La información en este sitio web no está dirigida a residentes de ningún país donde el comercio de FX y/o CFD esté restringido o prohibido por las leyes o regulaciones locales. Los CFD son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Entre el 74% y el 89% de las cuentas de inversores minoristas pierden dinero al operar con CFD. Es importante que considere su comprensión del funcionamiento de los CFD y si puede permitirse correr el alto riesgo de perder su dinero.',
		},
		default: {
			description:
				'Los servicios y productos ofrecidos por Tradeview Markets no se ofrecen dentro de los Estados Unidos (EE. UU.) y no se ofrecen a personas estadounidenses, según lo definido por la ley de EE. UU. La información en este sitio web no está dirigida a residentes de ningún país donde el comercio de FX y/o CFDs esté restringido o prohibido por leyes o regulaciones locales. Los CFDs son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Entre el 74% y el 89% de las cuentas de inversores minoristas pierden dinero cuando operan con CFDs. Debe considerar si comprende cómo funcionan los CFDs y si puede permitirse asumir el alto riesgo de perder su dinero.',
		},
		ltd: {
			description:
				'Los servicios y productos ofrecidos por Tradeview Ltd. no se ofrecen dentro de los Estados Unidos (EE. UU.) y no se ofrecen a personas estadounidenses, según lo definido por la ley de EE. UU. La información en este sitio web no está dirigida a residentes de ningún país donde el comercio de FX y/o CFDs esté restringido o prohibido por leyes o regulaciones locales. Los CFDs son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Entre el 74% y el 89% de las cuentas de inversores minoristas pierden dinero cuando operan con CFDs. Debe considerar si comprende cómo funcionan los CFDs y si puede permitirse asumir el alto riesgo de perder su dinero.',
		},
		latam: {
			description:
				'Los servicios y productos ofrecidos por Tradeview Financial Markets S.A.C. no se ofrecen dentro de los Estados Unidos (EE. UU.) y no se ofrecen a personas estadounidenses, según lo definido por la ley de EE. UU. La información en este sitio web no está dirigida a residentes de ningún país donde el comercio de FX y/o CFDs esté restringido o prohibido por leyes o regulaciones locales. Los CFDs son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Entre el 74% y el 89% de las cuentas de inversores minoristas pierden dinero cuando operan con CFDs. Debe considerar si comprende cómo funcionan los CFDs y si puede permitirse asumir el alto riesgo de perder su dinero.',
		},
		mena: {
			description:
				'Los servicios y productos ofrecidos por Tradeview Financial Markets S.A.C. no se ofrecen dentro de los Estados Unidos (EE. UU.) y no se ofrecen a personas estadounidenses, según lo definido por la ley de EE. UU. La información en este sitio web no está dirigida a residentes de ningún país donde el comercio de FX y/o CFDs esté restringido o prohibido por leyes o regulaciones locales. Los CFDs son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Entre el 74% y el 89% de las cuentas de inversores minoristas pierden dinero cuando operan con CFDs. Debe considerar si comprende cómo funcionan los CFDs y si puede permitirse asumir el alto riesgo de perder su dinero.',
		},
		term: 'Términos y condiciones',
		privacy: 'Políticas de privacidad',
		aml: 'Política de AML',
		withdrawal: 'Política de retiros',
		refund: 'Política de devoluciones',
		risk: 'Divulgación de riesgos',
	},

	//modal
	modal: {
		error: 'No podemos continuar con tu solicitud',
		description:
			'Lamentamos informarte que, debido a las regulaciones, no podemos ofrecer servicios a personas que residen en el territorio de los Estados Unidos.',
		thank: 'Gracias por tu interés en unirte a Tradeview.',
		btnRegulation: 'Visita la página de regulaciones',
	},

	//tooltips
	tooltips: {
		signature1:
			'Por favor, asegúrate de que la firma coincida con la que aparece en los documentos que has cargado previamente. Los formatos de archivo aceptados son: jpg, jpeg y png, con un tamaño máximo de archivo de 2MB.',
		sourceAccount: 'La cuenta desde la cuál se retirarán los fondos.',
		sourceAccountTransfer:
			'La cuenta desde la cuál voy a transferir los fondos. ',
		withdrawCurrency:
			'El principal tipo de divisa o moneda que vas a usar en tu cuenta. Se representa con las siguientes abreviaturas: <br><br> USD: Dólar estadounidense <br> EUR: Euro <br> GBP: Libra esterlina',
		currencyUSD: 'USD: Dólar estadounidense',
		currencyEUR: 'EUR: Euro',
		currencyJYP: 'JPY: Yen japonés',
		currencyCAD: 'CAD: Dólar canadiense',
		currencyGBP: 'GBP: Libra esterlina',
		targetAccount: 'La cuenta que va a recibir la transferencia de fondos. ',
		digitalWallets:
			'Para tu comodidad, aceptamos una amplia selección de billeteras digitales. Ten en cuenta que las tarifas pueden variar dependiendo de la fuente de financiación que elijas para tu depósito.',
		wireTransfers:
			'Para este método de depósito, deberás seleccionar tu banco, diligenciar la información requerida e iniciar la transferencia. Tus fondos estarán disponibles poco después de la validación de tu broker.',
		cardTransfers:
			'Para tus depósitos con tarjeta de crédito, aceptamos Visa, Mastercard y Apple Pay.',
		currencyUphold: `El principal tipo de divisa o moneda que vas a usar en tu cuenta. Se representa con las siguientes abreviaturas: <br/>USD: Dólar estadounidense<br/>EUR: Euro <br/>JPY: Yen japonés <br/>CAD: Dólar canadiense <br/>AUD: Dólar australiano <br/>CHF: Franco suizo <br/>GBP: Libra esterlina <br/>MXN: Peso mexicano <br/>ZAR: Rand Sudafricano`,
		currencyType:
			'El principal tipo de divisa o moneda que vas a usar en tu cuenta.',
		leverageTM:
			'El apalancamiento te permite controlar posiciones más grandes que las que te permite tu capital inicial, comúnmente se expresa con proporciones, como 50:1 o 100:1, representando los activos que puedes controlar en comparación con tu propio depósito. ',
		demoXleverage: 'Apalancamiento-X 1:400',
		demoILC: 'ILC: 1:200',
		demoStock: 'Sin apalancamiento 1:1',
		notSureAccount:
			'¿Aún no sabes cuál tipo de cuenta elegir? Puedes revisarlas aquí ',
		ltd: {
			withdrawCurrency:
				'El principal tipo de divisa o moneda que vas a usar en tu cuenta. Se representa con las siguientes abreviaturas: <br><br> USD: Dólar estadounidense <br> EUR: Euro <br> GBP: Libra esterlina',
		},
		latam: {
			withdrawCurrency:
				'El principal tipo de divisa o moneda que vas a usar en tu cuenta.',
		},
	},

	//register
	register: {
		goBack: 'Regresar',
		titleRegister: 'Registro de Cuenta',
		AccountDesc:
			'¡Bienvenido a nuestro portal de trading! Elige entre nuestras cuentas Demo o Real para comenzar tu viaje en el trading y descubrir la diferencia con Tradeview.',
		AccountChoose: '¿Qué tipo de cuenta te gustaría crear?',
		dinamicDescLive:
			'¿Aún no estás listo para una cuenta real? <spam>Crea una cuenta Demo.</spam>',
		dinamicDescDemo:
			'¿Quieres operar en una cuenta real? <spam>Crea una cuenta Real</spam>',
		getYour: '¡Empieza a hacer trading hoy!',
		or: 'O regístrate aquí:',
		email: 'Correo electrónico',
		secure: 'Crear contraseña',
		confirmPassword: 'Confirmar contraseña',
		disclaimer:
			'AVISO LEGAL: Antes de abrir una cuenta, es nuestra obligación en Tradeview Ltd. ("Tradeview") asegurarnos de que la persona/s designada/s para operar en su nombre tengan los conocimientos y la experiencia necesarios en CFD e instrumentos financieros relacionados. También tenemos como requisito cumplir con las obligaciones de LMA y CFT. En este sentido, solicitamos amablemente que proporcione información precisa, completa y veraz según lo solicitado en esta aplicación, para que podamos completar el cumplimiento de las obligaciones mencionadas anteriormente. Con base en esta información, podemos determinar adecuadamente si los servicios de inversión en relación con el/los instrumento/s financiero/s son apropiados para nuestro cliente. Todas las secciones deben completarse. Para obtener más detalles, consultar nuestro Contrato con el Cliente.',
		byTicking:
			'Al marcar esta casilla, declaras que estás de acuerdo con el aviso anterior.',
		getstarted: 'Continuar',
		messageFooter1: 'La oferta de servicios y productos por parte de ',
		messageFooter2:
			' no está disponible en los Estados Unidos (EE. UU.) y no están dirigidos a personas residentes de los EE. UU., según se define en la ley de este país. La información en este sitio web no está dirigida a residentes de ningún país donde el comercio de FX y/o CFD esté restringido o prohibido por las leyes o regulaciones locales. Los CFD son instrumentos complejos y conllevan un alto riesgo de perder dinero rápidamente debido al apalancamiento. Entre el 74% y el 89% de las cuentas de inversores minoristas pierden dinero al operar con CFD. Es importante que considere su comprensión del funcionamiento de los CFD y si puede permitirse correr el alto riesgo de perder su dinero.',
		client: 'Client Cabinet',
		instructionstitle1: '¡Ahorra tiempo y esfuerzo!',
		instructionstitle2: ' Una plataforma para cada una de',
		instructionstitle3: ' tus necesidades',
		options1f: 'Regulado ',
		options1l: 'y seguro',
		options2f: 'Asistencia ',
		options2l: 'personalizada',
		options3f: 'Liquidez ',
		options3l: 'incomparable',
		haveAccount: '¿Ya tienes una cuenta? ',
		signUp: ' Iniciar sesión',
		newCode: 'Se ha enviado un código de un solo uso a ',
		tryEgain:
			'No podemos reenviar su código en este momento. Por favor, intenta de nuevo.',
		invalidEmail: 'Formato no válido. Por favor, inténtalo de nuevo.',
		passwordRequired: 'Este campo es obligatorio. Por favor, ingrésalo.',
		invalidPassword:
			'La contraseña debe tener al menos 8 caracteres e incluir al menos una minúscula, una mayúscula, un número y un carácter especial.',
		confirmPasswordRequired: 'Este campo es obligatorio. Por favor, ingrésalo.',
		passwordsDoNotMatch:
			'Las contraseñas no coinciden. Por favor intenta de nuevo',
		errorDisclaimer:
			'Por favor, marque la casilla de confirmaciónpara continuar',
		firstNameError: 'Este campo es obligatorio. Por favor, ingrésalo.',
		typeAccountError: 'Por favor selecciona un tipo de cuenta',
		invalidName:
			'Tu nombre no puede tener números ni símbolos. Por favor, inténtalo de nuevo.',
		invalidLastName:
			'Tu apellido no debe contener números o símbolos. Por favor, intenta de nuevo. ',
		mfaCode: 'Ingresa el código MFA',
		startDemo: '¡Obtén tu Cuenta Demo Gratis ahora!',
		orRegister: 'O regístrate aquí:',
		verificationCode: 'Código de verificación',
		didntCode: '¿No recibiste ningún código? Reenviar el código',
		yourEmail: 'Tu correo electrónico ',
		firstName: 'Nombre',
		lastName: 'Apellido',
		accountType: 'Tipo de cuenta',
		accountCategory: 'Tipo de cuenta',
		accountCategoryPlaceholder: 'Selecciona un tipo de cuenta',
		accountCategoryTooltip: `<strong>Cuenta individual:</strong>  </br> Selecciona esta opción si deseas ser el único titular. </br></br> <strong>Cuenta conjunta:</strong>  </br> elige esta opción si estás abriendo una cuenta con otra persona, como una pareja o un socio comercial.  </br></br> <strong>Cuenta Corporativa:</strong> </br> Opta por esta opción si estás representando a una entidad; empresa u organización. `,
		entity: 'Entidad:',
		entityPLaceholder: 'Selecciona una entidad:',
		entityTooltip:
			'Seguimos rigurosos estándares financieros en todas las jurisdicciones en las que operamos. Conoce más aquí.',
		accountRegis: 'Registro de cuenta',
		countryTooltip:
			'Si tu país de residencia no está listado en las opciones, lamentamos informarte que no podemos ofrecer nuestros servicios en tu ubicación.',
		checkRegis:
			'Al marcar esta casilla, reconozco que ni Tradeview ni ningún individuo asociado con Tradeview me ha solicitado cambiar de entidad. ',
		changeRegion: 'Cambiar a la entidad de mi región',
		liveIndividual: 'Cuenta individual real </br> ¡Comienza a operar ahora!',
		jointIndividual: 'Cuenta conjunta real </br> ¡Comienza a operar ahora!',
		corporateIndividual:
			'Cuenta corporativa real </br> ¡Comienza a operar ahora!',
		entityText:
			'Estás a punto de seleccionar una entidad para la creación de tu cuenta que está establecida y regulada en una región diferente a tu país de residencia seleccionado.',
		entityTextEu: `El sitio web que estás visitando ahora es operado por una entidad que no está establecida en la Unión Europea ni regulada por una Autoridad Nacional Competente de la UE.<br><br> Al hacer clic en "Continuar", confirmas que Tradeview ni ninguna persona asociada con Tradeview te ha solicitado cambiar de entidad. <br><br> Para ser dirigido a la entidad regulada por la Unión Europea, Tradeview Europe Ltd., haz clic en "Cambiar a la entidad de mi región". Tradeview Europe Ltd. está regulada por la MFSA, lo cual es adecuado para tu jurisdicción.`,
		entitiesTitle: 'Entidades internacionales que operan bajo nuestra marca:',
		entitiesDesc: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>Regulated by the Cayman Islands Monetary Authority (CIMA) and operates under the Cayman Islands Laws (SIBL)</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (Global)</b> </li> </ul> <p>Registered with SUNARP, operates under the General Law of Companies (LGS)</p>`,
		entitiesDescEu: `<ul> <li> <b>Tradeview Ltd. (CIMA)</b> </li> </ul> <p>Regulated by the Cayman Islands Monetary Authority (CIMA) and operates under the Cayman Islands Laws (SIBL)</p>  <br> <ul> <li> <b>Tradeview Financial Markets S.A.C (Global)</b> </li> </ul> <p>Registered with SUNARP, operates under the General Law of Companies (LGS)</p> <br> <ul> <li> <b>TVM Global Ltd.</b> </li> </ul> <p>Regulated by the Labuan Financial Services Authority (FSA), licensed under Labuan laws.</p> `,
		individual: 'Individual',
		joint: 'Conjunta',
		corporate: 'Corporativa',
		individualIB: 'Cuenta individual IB',
		reloadPage:
			'Por favor actualiza la página para continuar. Esto solucionará un problema que impide la entrada de datos.',
		instructionsIB1: '¡Haz crecer tu negocio',
		instructionsIB2: 'de corretaje!  Conviértete en un IB',
		instructionsIB3: 'en menos de 5 minutos',
		titleIbRegister: '¿Nuevo en Tradeview Markets? ',
		disclaimerIBportal:
			"Aviso legal: Antes de abrir una cuenta, es nuestra obligación en Tradeview Financial Markets S.A.C. ('Tradeview') asegurarnos de que la persona/s designada/s para operar en su nombre tengan los conocimientos y la experiencia necesarios en CFD e instrumentos financieros relacionados. También tenemos como requisito cumplir con las obligaciones de LMA y CFT. En este sentido, solicitamos amablemente que proporcione información precisa, completa y veraz según lo solicitado en esta aplicación, para que podamos completar el cumplimiento de las obligaciones mencionadas anteriormente. Con base en esta información, podemos determinar adecuadamente si los servicios de inversión en relación con el/los instrumento/s financiero/s son apropiados para nuestro cliente. Todas las secciones deben completarse. Para obtener más detalles, consultar nuestro Contrato con el Cliente.",
		alreadyClient: '¿Ya eres cliente de Tradeview Markets? ',
		loginClientCabinet: ' Inicia sesión en tu Gabinete',
		registerIB: 'para registrarte como IB.',
		instructionsIBportal1: 'Lo tenemos cubierto!',
		instructionsIBportal2: 'Soluciones para cada',
		instructionsIBportal3: 'necesidad que tengas',
		options1f_ib_portal: 'Soluciones',
		options1l_ib_portal: 'integrales',
		options2f_ib_portal: 'Atención al cliente',
		options2l_ib_portal: 'disponible 24/5',
		options3f_ib_portal: 'Pagos diarios por descuentos',
		options3l_ib_portal: 'y comisiones',
		register_enjoy: 'Regístrate ahora y disfruta de:',
		fast_onboarding: 'Un proceso de onboarding rápido ',
		no_program: 'Un programa IB sin costos iniciales',
		fast_solutions: 'Un proceso de onboarding rápido y soluciones integrales',
	},

	'reset-password': {
		instructionstitle1: '¡Ahorra tiempo y esfuerzo',
		instructionstitle2: 'Una plataforma para cada una ',
		instructionstitle3: ' de tus necesidades',
		title: 'Establece una nueva contraseña',
		label1: 'Nueva contraseña',
		label2: 'Confirmar nueva contraseña',
		options1f: 'Regulado',
		options1l: 'y seguro',
		options2f: 'Asistencia',
		options2l: 'personalizada',
		options3f: 'Liquidez',
		options3l: 'incomparable',
	},

	//Calendar
	calendar: {
		title: 'Calendario',
	},

	//application process
	application: {
		optional: '(Opcional)',
		ifApplicable: '(Si aplica)',
		jobTitleL: 'Título del trabajo',
		jobTitleP: 'Ingrese su título del trabajo',
		emplymentAditionalDetails: 'Información adicional',
		taxResTitle: 'Tu declaración de residencia fiscal',
		taxResPurposes:
			'¿Eres ciudadano estadounidense o residente fiscal de EE. UU.?',
		taxLabelCompany:
			'La empresa confirma que, para fines fiscales, es residente en el siguiente país:',
		taxLabelIndividual:
			'Confirmo que, para fines fiscales, soy residente en el siguiente país:',
		taxResHereby:
			'Por este medio confirmo que, a efectos fiscales, soy residente en el siguiente país:',
		taxResCountryL: 'País',
		taxResCountryP: 'Selecciona un país',
		taxResMarketL: 'Número de referencia fiscal',
		taxResMarketP: 'Ingresa tu número de referencia fiscal',
		taxCode: '',
		taxResMarketTM:
			"Tu código de referencia fiscal puede ser enteramente numérico o consistir de una combinación de letras y números. Ten la seguridad de que tu información está segura con nosotros. Puedes obtener más información al respecto aquí. <a href='https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/' target='_blank'>aquí</a>",
		taxResPoliticalL:
			'¿Eres una persona expuesta políticamente (PEP), familiar cercano o asociado de una PEP?',
		taxResPoliticalTM:
			'Una PEP (Persona Expuesta Políticamente) es una persona que ocupa o ha ocupado un cargo destacado públicamente, con posibles implicaciones para la evaluación del riesgo financiero.',
		taxResStatusL:
			'¿Cuál es tu estado como PEP o cómo estás relacionado con un PEP?',
		taxResStatusP:
			'Por favor, proporciona detalles sobre tu condición como PEP o de tu relación con una persona expuesta políticamente',
		taxResStatusTM:
			'Es necesario que reveles tu estado como PEP o cualquier conexión relacionada para evaluar los riesgos tanto para ti como para Tradeview. Ten en cuenta que si eres un PEP o tienes alguna asociación con uno, aún puedes continuar con el proceso de solicitud.',
		taxCode: 'Código de referencia fiscal',
		taxCodeTooltip: `Tu código de referencia fiscal puede consistir en una combinación de letras y números o puede ser completamente numérico. Tu información está segura con nosotros. Estamos obligados a recopilar esta información de acuerdo con los estándares de reporte de la OCDE. Puedes obtener más información <a href="https://www.oecd.org/tax/automatic-exchange/common-reporting-standard/" target="_blank" rel="noopener noreferrer">aquí</a>.`,
		selectTaxCode: 'Ingresa tu código de referencia fiscal',
		accountTypeH: 'Tu tipo de cuenta',
		accountTypeD:
			'Estás solicitando tu primera cuenta de Tradeview. Después de crearla, podrás abrir fácilmente otras cuentas, para diferentes activos financieros sin necesidad de completar todo el formulario nuevamente.',
		tradingMarketL: 'Mercado de trading',
		tradingMarketP: 'Selecciona un mercado',
		tradingMarketTM:
			"Un mercado de trading es el mercado o intercambio donde un activo o un instrumento es listado o cotizado con el objetivo de trading. <br><br> ¿Aún no sabes cuál mercado elegir? Puedes revisarlos  <a href='https://www.tvmarkets.com/trading/markets' target='_blank'>aquí</a>",
		currencyTypeL: 'Tipo de divisa',
		currencyTypeP: 'Selecciona un tipo de divisa',
		currencyTypeTM:
			'El principal tipo de divisa o moneda que vas a usar en tu cuenta. Se representa con las siguientes abreviaturas: <br><br> USD: Dólar estadounidense <br> EUR: Euro <br> JPY: Yen japonés <br> CAD: Dólar canadiense <br> AUD: Dólar australiano <br> CHF: Franco suizo <br> GBP: Libra esterlina <br> MXN: Peso mexicano',
		platformL: 'Plataforma',
		platformP: 'Selecciona una plataforma',
		platformTM:
			"Una plataforma es un sistema de software para operar activos o instrumentos. <br><br> ¿Aún no sabes cuál plataforma elegir? Puedes revisarlas <a href='https://www.tvmarkets.com/trading/platforms' target='_blank'>aquí</a>",
		accountTypeL: 'Tipo de cuenta',
		accountTypeP: 'Selecciona un tipo de cuenta',
		accountTypeTM:
			"El tipo de cuenta determina el apalancamiento de tu cuenta. Las opciones son: <br><br> Apalancamiento-X 1:400 <br> ILC 1:200 <br> Sin apalancamiento 1:1 <br><br> ¿Aún no sabes cuál tipo de cuenta elegir? Puedes revisarlas <a href='https://www.tvmarkets.com/trading/accounts' target='_blank'>aquí</a>",
		emplymentDetailsH: 'Detalles de tu empleo ',
		employmentStatusL: 'Estado laboral',
		employmentStatusP: 'Selecciona un estado',
		employerL: 'Empleador',
		employerP: 'Ingresa el nombre de la empresa empleadora',
		occupationL: 'Ocupación',
		occupationP: 'Ingresa tu ocupación',
		industryL: 'Industria',
		industryP: 'Selecciona el tipo de industria',
		industryTM:
			'La industria describe las características fundamentales y actividades de la empresa para la que trabajas.',
		employmentTypeL: 'Tipo de empleo',
		employmentTypeP: 'Selecciona la naturaleza de tu empleo',
		employmentTypeTM:
			'El tipo de empleo describe las características fundamentales y las condiciones que definen tu estado o acuerdo laboral.',
		employmentAddressL: 'Dirección del empleador',
		employmentAddressP: 'Ingresa la dirección de tu empleador',
		employerCountryL: 'País del empleador',
		employerCountryP: 'Selecciona un país',
		employerProvinceL: 'Provincia del empleador',
		employerProvinceP: 'Selecciona una provincia',
		employerCityL: 'Ciudad del empleador',
		employerCityP: 'Selecciona una ciudad',
		employerZipL: 'Código postal/ZIP del empleador',
		employerZipP: 'Ingresa el código postal/ZIP del empleador',
		businessTypeL: 'Tipo de negocio',
		businessTypeP: 'Selecciona el tipo de negocio',
		businessTypeTM:
			'Los tipos de negocio se refieren a las diferentes estructuras legales y formas que pueden tomar las organizaciones o empresas cuando operan en el mundo empresarial.',
		businessCountryL: 'País de tu negocio',
		businessCountryP: 'Selecciona un país',
		businessProvinceL: 'Provincia de tu negocio',
		businessProvinceP: 'Selecciona una provincia',
		businessCityL: 'Ciudad de tu negocio',
		businessCityP: 'Selecciona una ciudad',
		businessLocationL: 'Dirección de tu negocio',
		businessLocationP: 'Ingresa la dirección de tu negocio',
		businessNameL: 'Nombre de tu negocio',
		businessNameP: 'Ingrese el nombre de tu negocio',
		businessWebL: 'Sitio web de tu negocio',
		businessWebP: 'Ingresa la URL del sitio web de tu negocio',
		businessIndustryL: 'Industria',
		businessIndustryP: 'Selecciona la naturaleza de tu negocio',
		businessIndustryTM:
			'La industria describe las características fundamentales y actividades de la empresa para la que trabajas.',
		financialDetailsH: 'Tus detalles financieros',
		annualIncomeL: '¿Cuál es tu ingreso anual o volumen de negocios total?',
		totalAssetsL: '¿Cuál es el balance total de tus activos?',
		totalAssetsTM:
			'El balance de tus activos es el valor de tus ahorros, inversiones, propiedades de bienes raices después de deducir los compromisos. ',
		liquidAssetsL: '¿Cuál es el balance de tus activos líquidos?',
		liquidAssetsTM:
			'El balance de tus activos líquidos es la suma de tu dinero en efectivo, instrumentos de mercado monetario y valores negociables. ',
		tradeAnnuallyL: '¿Cuánto planeas invertir/operar anualmente? ',
		originAssetsL: '¿Cuál es el origen de tus activos totales?',
		originDepositsL: '¿Cuál es el origen o la fuente de tus depositos/fondos? ',
		purposeAccountL: '¿Cuál es el propósito de la cuenta?',
		bankruptciesDetailsL: 'Detalles de la bancarrota',
		bankruptciesDetailsP:
			'Agrega información sobre la(s) bancarrota(s) con la(s) que tienes vinculación. ',
		bankruptciesDetailsTM:
			'Solicitamos que reveles cualquier afiliación a bancarrotas para abordar los riesgos tanto para ti como para Tradeview. <br><br> No obstante, ten la seguridad de que si estás vinculado a alguna bancarrota, aún puedes continuar con tu proceso de solicitud.',
		bankruptciesConnetL: '¿Tienes alguna vinculación a bancarrotas?',
		tradingExperienceH: 'Tu experiencia en trading',
		tradingExperienceD:
			'Selecciona las opciones que mejor representen tu experiencia en trading de Forex, Stocks, Futuros, Derivados o CFDs.',
		tradingExperienceDMENA:
			'Selecciona la opción que mejor represente tu experiencia operando en Forex, Acciones, Derivados o CFDs.',
		tradingExperienceTM:
			'Preguntamos sobre tu experiencia en trading para poder ofrecerte orientación, apoyo personalizado y una óptima experiencia de trading, sin importar si eres un trader experimentado o estás comenzando.',
		yearsTradingL: '¿Cuántos años acumulas de experiencia en trading?',
		yearsTradingP: 'Selecciona una opción',
		tradingVolumenL: '¿Cuál es tu volumen de trading?',
		tradingVolumenP: 'Selecciona una opción',
		oftenTradeL: '¿Con qué frecuencia haces trading?',
		oftenTradeP: 'Selecciona una opción',
		identityH: 'Verificación de identidad',
		identityDesc:
			'Para completar la verificación, necesitarás uno de los siguientes documentos:',
		identityD:
			'Confirmar tu identidad con un documento emitido por el gobierno garantiza la seguridad y legitimidad de tu cuenta. ',
		identityDLatam:
			'Para una experiencia más fluida, te sugerimos completar este paso en tu celular usando el código QR a continuación.Vas a necesitar uno de los siguientes documentos para verificar tu identidad:',
		idDocumentL: 'Documento de identidad',
		idDocumentP: 'Selecciona el tipo de documento',
		idDocumentTM:
			'Aceptamos los siguientes documentos para confirmar tu identidad: <br> <br> Pasaporte (sugerido) <br> Tarjeta nacional de identidad <br> Permiso de residencia <br> Licencia de conducción',
		idDocumentUploadL: 'Carga de documentos',
		idDocumentUploadTM:
			'Asegúrate que la información e imagen en el archivo sea clara y entendible.',
		idDocumentFrontL: 'Parte delantera',
		idDocumentFrontTM:
			'La parte delantera de tu documento de identidad contiene tu foto, nombre completo y número de identidad. ',
		idDocumentBackL: 'Parte trasera',
		idDocumentBackTM:
			'La parte trasera de tu documento de identidad contiene información adicional como tu dirección y otros datos relevantes. ',
		proofResidenceH: 'Tu comprobante de domicilio',
		proofResidenceHYour: 'Tu comprobante de residencia',
		proofResidenceD:
			'Confirma tu ubicación para garantizar el cumplimiento de los estándares regulatorios. ',
		proofResidenceL: 'Documento de comprobante de domicilio',
		proofResidenceP: 'Selecciona el tipo de documento',
		proofResidenceTM:
			'Para verificar tu dirección, por favor carga alguno de estos documentos: <br><br>  • Factura de servicios  <br>  • Estado de cuenta bancaria (con historia transaccional) <br> • Certificado de residencia     <br><br>   Las facturas aceptadas incluyen:   <br>• Gas    <br>• Electricidad  <br>  • Agua  <br>  • Línea telefónica  <br>  • Internet (si está conectado a la residencia)  <br>  • Cable (si está conectado a la residencia)  <br><br>    No aceptamos facturas de celular o estados de banco que muestran grandes cantidades de dinero depositadas. ',
		proofUploadL: 'Carga de documentos',
		proofUploadTM:
			'Asegúrate de que el documento: <br><br> • No tenga más de 3 meses de antiguedad <br>• Incluya tu nombre <br>• Tenga una dirección que coincida con la de tu aplicación <br>• No sea un pantallazo <br>• No esté cortado<br>• No tenga información bloqueada o enmascarada <br>• Esté en un idioma que se pueda traducir',
		addressDetail: 'Dirección',
		financialDetailsTM:
			'Para garantizar una evaluación asertada de los riesgos para ti y para Tradeview, necesitamos información detallada sobre tus finanzas.',
		acknowledgementH: 'Reconocimiento',
		acknowledgementCheck:
			'Al marcar esta casilla, reconozco que he leído, comprendido y estoy de acuerdo con toda la información contenida en los documentos enumerados arriba.',
		signatureH: 'Firma',
		signatureP1:
			'Al firmar a continuación, reconozco y acepto los documentos enumerados en el paso anterior de este proceso. ',
		signatureP2:
			'Además, reconozco y acepto, bajo penalidad por falso testimonio, que toda la información proporcionada en la solicitud es verdadera y precisa, y que todos los depósitos en mi cuenta, independientemente de su origen, tipo de divisa o método de depósito, son derivados de fuentes legales y legitimas, no de actividad ilegal o criminal.',
		signatureMethod: '¿Cuál método de firma prefieres usar?',
		signatureDraw: 'Dibujar firma',
		signatureUpload: 'Cargar un archivo',
		signatureTM:
			'Por favor, asegúrate de que la firma coincida con la que aparece en los documentos que has cargado previamente. Los formatos de archivo aceptados son: jpg, jpeg y png, con un tamaño máximo de archivo de 2MB.',
		signatureAD: 'Firma del cliente autorizado',
		additionalRiskH: 'Divulgación adicional de riesgos',
		additionalRiskD1:
			'La información proporcionada en tu solicitud de apertura de cuenta indica que no cumples con las pautas de Tradeview Ltd. para abrir una cuenta de trading por una de las siguientes razones: ',
		additionalRiskP1Latam:
			'Además de los avisos de riesgo estándar de la industria incluidas dentro del Acuerdo de Cuenta de Cliente de Tradeview Markets, debes tener en cuenta que el trading de forex se considera una forma de inversión riesgosa. Si solo haz realizado inversiones conservadoras en el pasado, es posible que desees estudiar el trading de forex más a fondo antes de continuar con una inversión de esta naturaleza.',
		additionalRiskP2Latam:
			'Si deseas continuar con tu inversión, reconoces que los fondos que haz comprometido son capital de riesgo y la pérdida de su inversión no pondrá en peligro tu estilo de vida ni afectará tu futuro programa de jubilación. Además, comprendes plenamente la naturaleza y los riesgos de las inversiones en forex, y tus obligaciones hacia otros no se verán descuidadas en caso de que sufras pérdidas de inversión.',
		additionalRiskUl1: 'No tienes entre 21 y 63 años',
		additionalRiskUl2: 'Tu ingreso anual es menor a $25,000 USD',
		additionalRiskUl3: 'Te has declarado en bancarrota en el último año',
		additionalRiskUl4: 'No estás empleado ',
		additionalRiskD2:
			'Aunque Tradeview Ltd. está dispuesto a abrir tu cuenta, es necesario aconsejarte que reconsideres esta inversión. Basándonos en tu información personal y/o experiencia en inversiones, el mercado de divisas (forex) podría ser una estrategia de inversión demasiado arriesgada. Las pérdidas en el trading de forex pueden ser sustanciales. Por lo tanto, te invitamos a considerar cuidadosamente si este tipo de trading es el adecuado para ti en función de tus circunstancias y recursos financieros. El alto grado de apalancamiento que se obtiene en el trading de forex debido al bajo margen de requerimiento puede resultar en tu contra, así como a tu favor. El uso del apalancamiento puede llevar a grandes pérdidas, así como también a grandes ganancias.',
		additionalRiskChk1:
			'Entiendo que no cumplo con las pautas mínimas establecidas para abrir una cuenta según lo establecido por Tradeview Ltd. en los párrafos anteriores. Sin embargo, he considerado los riesgos financieros involucrados en el forex trading en relación a mi situación personal y deseo continuar con la apertura de una cuenta. ',
		additionalRiskChk2:
			'Reconozco que he leído lo anterior y comprendo por completo la información proporcionada en este documento.',
		additionalRiskChk1Latam:
			'Soy consciente de los riesgos inherentes asociados con mi cuenta de trading y he considerado todas las posibles consecuencias de perder mi inversión. Habiendo leído los riesgos asociados con el trading de forex, estoy dispuesto a continuar con el proceso de apertura de cuenta.',
		additionalRiskChk2Latam:
			'Reconozco que he leído lo anterior y comprendo por completo la información proporcionada en este documento.',
		submitApplicationH: 'Enviar solicitud',
		submitApplicationD1:
			'¡Ya casi terminas! Valoramos tu esfuerzo al completar esta solicitud.',
		submitApplicationD2:
			"Cuando estés listo, solo haz clic en el botón 'Enviar'. ",
		submitApplicationD3:
			'Si tienes alguna pregunta o necesitas asistencia, no dudes en',
		submitApplicationLink: 'contactarnos',
		submitApplicationCheck:
			'Yo/Nosotros aceptamos ser incluidos en la lista de distribución de marketing',
		applicationSubmitedH: 'Solicitud enviada: En proceso de revisión',
		applicationSubmitedD1:
			'Gracias por enviar la solicitud de tu cuenta individual. Ahora está bajo revisión y será verificada pronto.',
		applicationSubmitedD2:
			'Nuestro equipo se pondrá en contacto contigo si necesitamos más documentación.',
		applicationSubmitedD3:
			'Agradecemos tu cooperación y te mantendremos informado sobre el progreso.',
		applicationSubmitedGT: 'Ir a mi gabinete',
		applicationSubmitedET: 'Explorar Tradeview',
		apEmailL: 'Correo electrónico',
		apFirstNL: 'Nombre',
		apFirstNP: 'Nombre',
		apLastNL: 'Apellido',
		apLastNP: 'Apellido',
		apDateBL: 'Fecha de nacimiento',
		apCountryBL: 'Pais de nacimiento ',
		apCountryBP: 'Selecciona el pais',
		apCountryNL: 'Nacionalidad',
		apCountryNP: 'Selecciona tu nacionalidad',
		apMobileL: 'Celular (Opcional)',
		apPhoneL: 'Teléfono',
		apPassL: 'Número de identidad/ Número de pasaporte o NIS',
		apPassP: 'Ingresa tu número de identificación',
		apPassT:
			'Solamente necesitas ingresar uno de los documentos de identificación. Ten en cuenta que el Número de Seguro Social (NSS) solamente es requerido para usuarios en Canadá.',
		apPassDL: 'Fecha de expiración de tu número de identidad, pasaporte o NIS',
		apGenderL: 'Género',
		apGenderP: 'Selecciona una opción',
		apMaritalL: 'Estado marital',
		apMaritalP: 'Selecciona una opción',
		apCountryRL: 'País de ubicación',
		apCountry: 'País',
		apCountryRLTooltip: `Esto se refiere al país donde su negocio está principalmente ubicado. La información precisa nos ayuda a personalizar nuestros servicios según los requisitos y regulaciones regionales. Si su país de ubicación no está listado en las opciones, lamentamos informarle que no podemos ofrecer nuestros servicios en su ubicación.`,
		apCountryRLResidence: 'País de residencia',
		apCountryRP: 'Selecciona un país',
		apProvinceRL: 'Estado/Provincia',
		apProvinceRP: 'Selecciona una provincia',
		apCityRL: 'Ciudad',
		apCityRP: 'Selecciona una ciudad',
		apStreethRL: 'Nombre de la calle',
		apStreethRD: 'Ingresa el nombre de la calle',
		apStreethNL: 'Número de la calle',
		apStreethND: 'Ingresa el número de la calle',
		apPostCL: 'Código postal',
		apPostCD: 'Ingresa el código postal',
		appAddresT:
			'Si el país de residencia no está listado entre las opciones, lamentamos informarte que estamos inhabilitados para ofrecerte nuestros servicios en tu ubicación',
		modalCompleteT: 'Toda la información ha',
		modalCompleteT2: 'sido completada!',
		modalCompleteP:
			'Tenemos toda la información necesaria para completar el proceso. El último paso es agregar la firma del titular de la cuenta y enviar la solicitud. ¡Tu viaje está casi completo!',
		modalRegulationT: 'No podemos continuar ',
		modalRegulationT2: 'con tu solicitud',
		modalRegulationP:
			'Lamentamos informarte que, debido a las regulaciones, no podemos ofrecer servicios a personas que residen en el territorio de los Estados Unidos.',
		modalRegulationP2: 'Gracias por tu interés en unirte a Tradeview.',
		signatureTM2:
			'Por favor, asegúrate de que la firma coincida con la de los documentos que cargaste. Los formatos de archivos permitidos son jpg, jpeg y png, el tamaño máximo es de 2MB.',
		submitModal:
			'Detectamos algunos errores en el formulario, por favor revisa e intenta de nuevo. Si el problema continua, por favor contactános. ',
		areaPH: 'Area',
		phonePH: 'Ingresa tu número de celular',
		emailPH: 'Ingresa tu correo eléctronico',
		errorUpload: 'Por favor, sube el archivo en un formato y tamaño válido. ',
		apBtnContinue: 'Continuar',
		apBtnSubmit: 'Enviar',
		apBtnBack: 'Regresar',
		apBtnRegulation: 'Visita la página de regulaciones',
		complete: 'Completo',
		pending: 'Pendiente',
		rejected: 'Rechazado',
		accepted: 'Aceptado',
		enterFirstName: 'Ingresa tu primer nombre',
		enterLastName: 'Ingresa tu apellido',
		enterAnEmail: 'Ingresa un correo electronico',
		sendInvitation: 'Enviar invitación',
		invitationSent: 'La invitación ha sido enviada con éxito.!',
		invitationSentDesc:
			'Puedes hacerle seguimiento a tu proceso de aplicación en la pestaña de Adición a titular secundario de la cuenta. ',
		modifiedInvitation:
			'La información del cotitular de la cuenta fue actualizada con éxito',
		modifiedInvitationDesc:
			"Envíamos una invitación al correo electrónico del cotitular. Puedes seguir el progreso de la aplicación en la página de 'Cotitular de la cuenta'.",
		notModifiedInvitation:
			'La información del cotitular de la cuenta fue actualizada con éxito',
		notModifiedInvitationDesc:
			"Puedes seguir el progreso de tu aplicación en la página de 'Cotitular de la cuenta'",
		resend: 'Reenviar invitación',
		saveShareholder: 'Guardar accionista',
		shareholderToComplete: 'Invitar al accionista para terminar',
		companyDocuments: 'Documentos de la empresa',
		companyDocumentsDesc:
			'Verifica tu cuenta corporativa para garantizar el cumplimiento de los estándares y así poder adaptar nuestros servicios a las necesidades de tu negocio.',
		documentUpload: 'Carga de documentos',
		documentUploadTooltip1:
			'Asegúrate de que la información e imágenes en tus archivos sean claras y comprensibles.',
		documentUploadTooltip2:
			'Puedes subir los documentos que tengas en este momento. Si faltan algunos, ¡No te preocupes! de ser solicitados, puedes subirlos o enviarlos más tarde por correo electrónico.',
		documentUploadDesc:
			'Selecciona si deseas cargar ahora los documentos o cargarlos luego. Si eliges subirlos ahora, simplemente arrastra los archivos y suéltalos aquí, o haz clic para buscarlos en tu dispositivo.',
		articlesIncorp: 'Acta constitutiva',
		certificateIncorp: 'Certificado de constitución',
		shareholderBreak: 'Detalle de participación de accionistas',
		corporateBank: 'Estado de cuenta bancaria de la empresa',
		memorandumArticles: 'Memorando de asociación/estatutos sociales ',
		uploadNow: '¿Deseas cargar los documentos ahora?',
		imageType:
			'Asegúrate de que el archivo esté en formato JPEG, PNG, o PDF y su tamaño no supere los 2MB. ',
		sharesError:
			'El porcentaje de participación combinado del titular de la cuenta y los accionistas no puede superar el 100%. Por favor, intenta de nuevo.',
		inviteConfirmation: '¿Listo para envíar todas las invitaciones?',
		inviteConfirmationDesc:
			'Enviaremos un correo electrónico a todos los accionistas que agregues a tu cuenta. Por favor, ten en cuenta que una vez enviado, no podrás agregar más accionistas.',
		inviteSent: '¡La invitación fue enviada con éxito!',
		inviteSentDesc:
			'Puedes seguir el progreso de aplicación de cada accionista en la pestaña Adición de accionistas.',
		deleteHolder: '¿Quieres eliminar este accionista?',
		deleteHolderDesc:
			'Estás a punto de eliminar un accionista de la cuenta vinculado a tu cuenta corporativa, ¿Quieres continuar?',
		unableToContinue: 'No podemos continuar',
		unableToContinueDesc:
			'El correo electrónico que proporcionaste ya está asociado a una cuenta de Tradeview. Por favor, ingresa otro correo electrónico para continuar. ',
		provideAnother: 'Ingresar otro correo electrónico',
		duplicated: 'Duplicado',
		duplicatedDesc:
			'La dirección de correo electrónico ya está asociada a una cuenta de Tradeview. Por favor, proporciona un correo electrónico diferente para continuar.',
	},

	//validations yup app process
	yup: {
		selectOption: 'Por favor, selecciona una opción',
		phone: 'Tu número de celular no debe contener letras o simbolos',
		phoneValid: 'Por favor, Ingresa un número valido',
		dateofBirth: 'Por favor, ingresa tu fecha de nacimiento',
		validEmail: 'Por favor, ingresa un correo electrónico válido',
		mustBeAdult:
			'Por favor, ingresa una fecha de nacimiento valida. Debes tener mas de 18 años para continuar',
		passport: 'Por favor, ingresa tu número de identificación',
		passportValid: 'Por favor, usa un número valido',
		passportexpirationdate: 'Por favor, ingresa una fecha valida',
		passportexpirationdateValid:
			'Por favor, ingresa una fecha de expiración válida. Solo aceptamos documentos vigentes.',
		streetname: 'Por favor,  ingresa el nombre de la calle',
		streetnumber: 'Por favor, ingresa el número de la calle',
		postcode: 'Por favor, ingresa el código postal ',
		taxReference:
			'Tu código de referencia fiscal no debe contener espacios o símbolos. Por favor, intenta de nuevo.',
		pepstatus: 'Por favor, ingresa la información solicitada',
		pepstatusValid: 'Excede el máximo de caracteres',
		employer: 'Por favor, ingresa el nombre de la empresa empleadora',
		occupation: 'Por favor, ingresa tu ocupación',
		employerAddress: 'Por favor, ingresa la dirección de tu empleador',
		employerpostalcode:
			'Por favor, ingresa el código postal/ZIP de tu empleador',
		businesstype: 'Por favor, ingresa el tipo de negocio',
		industry: 'Por favor, ingresa la industria a la que pertenece tu negocio',
		business_location: 'Por favor, ingresa la dirección de tu negocio',
		business_name: 'Por favor, ingresa el nombre de tu negocio',
		business_website: 'Por favor, ingresa la URL del sitio web de tu negocio',
		bankruptciesdetails:
			'Por favor, escribe los detalles de tu afiliación a la(s) bancarrota(s).',
		acknowledgement:
			'Por favor, marca la casilla de reconocimiento para continuar',
		agree: 'Por favor, marca la casilla para continuar',
		expirationDate: 'Fecha de expiración invalida',
		invalidEmail: 'Formato invalido de correo electronico',
		EmailRequired: 'Correo electrinico obligatorio',
		companyName: 'Por favor, ingresa el nombre de la empresa matriz',
		email: 'Por favor, ingresa un correo electrónico de la empresa',
		businessDescription: 'Por favor, ingresa la información solicitada',
		required: 'Este campo es obligatorio',
		jobTitle: 'Por favor, ingrese su título de trabajo',
		emailAlreadyRegistered:
			'El correo electrónico ingresado ya está registrado. Por favor, usa uno diferente.',
	},

	//helper arrays app proces
	array: {
		usd: 'USD',
		eur: 'EUR',
		gbp: 'GBP',
		female: 'Femenino',
		male: 'Masculino',
		noBinary: 'No binario',
		other: 'Otro',
		noAnswer: 'Prefiero no contestar',
		single: 'Soltero',
		married: 'Casado',
		divorced: 'Divorciado',
		windowed: 'Viudo',
		registered: 'Unión civil registrada',
		yes: 'Si',
		no: 'No',
		employed: 'Empleado',
		selfEmployed: 'Trabajador autónomo',
		retired: 'Retirado',
		unemployed: 'Desempleado',
		aerospaceAndDefense: 'Aeroespacial y defensa',
		agriculture: 'Agricultura',
		automotive: 'Automotriz',
		construction: 'Construcción',
		consulting: 'Consultoría',
		eCommerce: 'Comercio electrónico',
		education: 'Educación',
		energyAndUtilities: 'Energía y servicios públicos',
		entertainmentAndMedia: 'Entretenimiento y medios',
		fashionAndApparel: 'Moda y ropa',
		financeAndBanking: 'Finanzas y banca',
		foodAndBeverage: 'Alimentos y bebidas',
		government: 'Gobierno',
		healthAndWellness: 'Salud y bienestar',
		hospitality: 'Hospitalidad',
		itTechnology: 'TI/Tecnología',
		legalServices: 'Servicios legales',
		manufacturing: 'Manufactura',
		marketingAndAdvertising: 'Marketing y publicidad',
		nonProfitCharity: 'Organización sin ánimo de lucro',
		realEstate: 'Bienes raíces',
		retail: 'Venta al por menor',
		serviceProvider: 'Proveedor de servicios',
		telecommunications: 'Telecomunicaciones',
		transportationAndLogistics: 'Transporte y logística',
		apprenticeship: 'Aprendíz',
		casual: 'Casual',
		contractual: 'Contrato ocasional',
		freelance: 'Freelance',
		fullTime: 'Tiempo completo ',
		internship: 'Práctica profesional',
		onDemand: 'Sobre pedido ',
		outsourcedOrOffshore: 'Tercerizado en el extranjero',
		partTime: 'Medio tiempo',
		permanent: 'Permanente',
		projectBased: 'Por proyecto',
		regular: 'Regular',
		seasonal: 'De temporada',
		temporary: 'Temporal',
		volunteer: 'Voluntario',
		benefitCorporation: 'Corporación de beneficio (B Corp)',
		cooperative: 'Cooperativa',
		cooperativeCorporation: 'Corporación cooperativa',
		corporation: 'Corporación',
		familyOwnedBusiness: 'Empresa familiar',
		franchise: 'Franquicia',
		holdingCompany: 'Holding empresarial',
		jointVenture: 'Empresa conjunta',
		llc: 'Compañía de responsabilidad limitada (CRL)',
		lllp: 'Sociedad de responsabilidad limitada limitada (SRL)',
		llp: 'Sociedad de responsabilidad limitada (SRL)',
		lp: 'Sociedad en comandita simple (SCS)',
		limitedLiabilityCompany: 'Compañía de responsabilidad limitada (CRL)',
		limitedLiabilityLimitedPartnership:
			'Sociedad de responsabilidad limitada limitada (SRL)',
		limitedLiabilityPartnership: 'Sociedad de responsabilidad limitada (SRL)',
		limitedPartnership: 'Sociedad en comandita simple (SCS)',
		nonprofitOrganization: 'Organización sin ánimo de lucro',
		partnership: 'Asociación',
		privateEquityFirm: 'Firma de capital privado',
		professionalCorporation: 'Corporación profesional (PC)',
		publiclyTradedCompany: 'Empresa cotizada en bolsa',
		sCorporation: 'Corporación S',
		socialEnterprise: 'Empresa social',
		soleProprietorship: 'Empresario individual',
		below25: 'Por debajo de $25,000 USD',
		between50: 'Entre $25,000 USD - $50,000 USD',
		between100: 'Entre $50,000 USD - $100,000 USD',
		over100: 'Más de $100,000 USD',

		// CORPORATE
		below50mil: 'Por debajo de $50,000 USD',
		between100mil: 'Entre $50,000 USD - $100,000 USD',
		between500mil: 'Entre $100,000 USD - $500,000 USD',
		between1000mill: 'Entre $500,000 USD - $1,000,000 USD',
		over1000mill: 'Más de $1,000,000 USD',
		// END CORPORATE

		savingsFromSalary: 'Ahorros de mi salario',
		governmentAid: 'Ayuda gubernamental',
		sale: 'Venta',
		investmentsDividends: 'Inversiones, dividendos',
		incomeFromATrust: 'Ingresos de un fideicomiso',
		letting: 'Renta',
		inheritance: 'Herencia',
		donation: 'Donación',
		loan: 'Préstamo',
		incomeFromSelfEmployment: 'Ingresos por cuenta propia',
		parentsPartnerOrOther: 'Padres, socios u otros',
		relativeSupport: 'Apoyo de parientes',
		hedging: 'Cobertura',
		speculation: 'Especulación',
		longTermInvesting: 'Inversión a largo plazo ',
		proprietaryTrading: 'Trading de propiedades',
		drawSignature: 'Dibujar firma',
		uploadSignature: 'Cargar un archivo',
		neverTraded: 'Nunca he hecho trading',
		zeroToFiveYears: '0-5 años',
		sixToTenYears: '6-10 años',
		overTenYears: 'Más de 10 años',
		below50K: 'Por debajo de $50,000 USD',
		between50KTo100K: 'Entre $50,000 USD - $100,000 USD',
		between100KTo500K: 'Entre $100,000 USD - $500,000 USD',
		over500K: 'Más de $500,000 USD',
		daily: 'Diariamente',
		weekly: 'Semanalmente',
		monthly: 'Mensualmente',
		quarterly: 'Trimestralmente',
		semiAnnually: 'Semestralmente',
		clientAgreement: 'Acuerdo del cliente',
		electronicTradingAgreement: 'Acuerdo de trading electrónico',
		riskDisclosure: 'Divulgación de riesgos',
		privacyPolicy: 'Política de privacidad',
		consentToDelivery:
			'Consentimiento para la entrega de estados de cuenta por medios electrónicos',
		commissionAgreement: 'Acuerdo de comisión',
		termsAndConditions: 'Términos y condiciones',
		swapFreeAccount: 'Reconocimiento de Cuenta Libre de Swap',
		swapFree: 'Formulario de solicitud de cuenta sin swap',
		forex: 'Forex',
		stocks: 'Acciones',
		futures: 'Futuros',
		months: {
			january: 'Enero',
			february: 'Febrero',
			march: 'Marzo',
			april: 'Abril',
			may: 'Mayo',
			june: 'Junio',
			july: 'Julio',
			august: 'Agosto',
			september: 'Septiembre',
			october: 'Octubre',
			november: 'Noviembre',
			december: 'Diciembre',
		},
		passport: 'Pasaporte',
		identityCard: 'Tarjeta nacional de identidad',
		residencePermit: 'Permiso de residencia',
		driversLicense: 'Licencia de conducción',
		utilityBill: 'Factura de servicios',
		bankStatement: 'Estado de cuenta bancaria',
		certificateResidency: 'Certificado de residencia',
		today: 'Hoy',
		lastWeek: 'La última semana',
		lastMonth: 'El último mes',
		last3Months: 'Los últimos 3 meses',
		last6Months: 'Los últimos 6 meses',
		costumPeriod: 'Periodo personalizado',
		lastQuarter: 'Ultimo trimestre',
		lastSemester: 'Ultimo semestre',
		lastYear: 'Ultimo año',
		step: 'Paso',
		sell: 'Vender',
		buy: 'Comprar',
		transfer: 'Transferir',
		deposit: 'Depositar',
		withdrawal: 'Retiro',
		payout: 'Pago',
		adjustment: 'Ajuste',
		live: 'Real',
		demo: 'Demo',
	},

	//MFA
	mfa: {
		body: 'Además de tu contraseña, configura un método de verificación secundario para mantener tu cuenta aún más segura.',
		text: 'Cuando habilitas la autenticación de factor doble, necesitas ingresar tu contraseña y el código de verificación que envíamos a tu correo electrónico. ',
		turn: 'Cuando habilitas la autenticación de factor doble, necesitas ingresar tu contraseña y el código de verificación que envíamos a tu correo electrónico. ',
		on: 'On',
		off: 'Off',
		confirm: 'Confirmar',
		textTwo: '¿Estas seguro que quieres deshabilitar el MFA?',
		yes: 'Si',
		no: 'No',
	},

	//PROGRESS
	progress: {
		title: 'Proceso de aplicación',
		progress1: 'Detalles personales',
		progress2: 'Residencia fiscal',
		progress3: 'Tipo de cuenta',
		progress31: 'Configuración de cuenta',
		progress4: 'Detalles laborales',
		progress5: 'Detalles financieros',
		progress6: 'Experiencia en trading',
		progress7: 'Verificación de identidad',
		progress8: 'Comprobante de domicilio',
		progress9: 'Reconocimiento',
		progress91: 'Consentimiento y Envío',
		progress10: 'Firma',
		progress11: 'Divulgación adicional de riesgos',
		progress12: 'Envío de solicitud',
		progress121: 'Envío',
		progress13: 'Cotitular de la cuenta',
		progress131: 'Adición de cotitular secundario',
	},

	//BTNS
	btns_: {
		back: 'Regresar',
		continue: 'Continuar',
		cancel: 'Cancelar',
		yesDelete: 'Si, eliminar',
		noDelete: 'No, Regresar',
		resendInvitations: 'Reenviar invitación',
		of: 'de',
		yesImSure: 'Sí, estoy seguro',
		submit: 'Enviar',
	},
	trading_tools: {
		main_title: 'Tus herramientas de trading',
		main_desc:
			'Toma decisiones más inteligentes y basadas en datos con nuestras potentes herramientas de trading, diseñadas para darte la ventaja en el mercado.',
		calculatorSuite: 'Suite de calculadoras',
		calculatorSuiteDesc:
			'¡Prepárate con todos los infaltables para el trading estratégico! Este kit está diseñado para empoderarte y elevar tu potencial, independientemente de tu nivel de trading.',
		tradegatehub: 'TradeGATEHub',
		tradegatehubDesc:
			'Accede a recursos gratuitos y enfocados en el crecimiento, como live chat con traders y expertos, transmisiones en vivo y noticias del mercado en tiempo real para construir la confianza de navegar los mercados como un profesional. ',
		surfsup: 'Surf’s Up!',
		surfsupDesc:
			'Mantente al día con los últimos desarrollos del mercado y explora nuevas estrategias, análisis e insights.',
	},
	authErrors: {
		default:
			'Ocurrió un error inesperado. Por favor, intenta nuevamente más tarde.',

		register: {
			usernameExists:
				'Este correo electrónico ya está registrado. Inicia sesión o utiliza uno distinto',
			invalidPassword:
				'La contraseña debe tener al menos 8 caracteres e incluir una minúscula, una mayúscula, un número y un carácter especial',
			invalidParameter:
				'Algunos datos ingresados son incorrectos o están incompletos. Revisa tu información e inténtalo de nuevo',
			aliasExists:
				'Este correo electrónico o número de contacto ya está asociado a otra cuenta. Inicia sesión o usa uno distinto',
			limitExceeded:
				'Se han solicitado demasiados códigos de verificación. Espera un momento e inténtalo de nuevo',
			notAuthorized:
				'No pudimos procesar tu registro debido a un problema de autorización. Inténtalo de nuevo más tarde',
			codeMismatch:
				'El código ingresado no es válido. Verifícalo e inténtalo nuevamente',
		},

		login: {
			userNotFound:
				'El correo electrónico que ingresaste no está registrado. Revisa si hay errores tipográficos o regístrate con una nueva cuenta',
			notAuthorized:
				'No se pudo iniciar sesión. Verifica tus credenciales e inténtalo de nuevo. Si el problema persiste, contáctanos',
			invalidPassword:
				'Las credenciales que ingresaste no son correctas. Revísalas e inténtalo nuevamente',
			codeMismatch:
				'El código ingresado no es válido. Verifícalo e inténtalo nuevamente',
			userNotConfirmed:
				'Verifica tu cuenta antes de iniciar sesión. Revisa tu correo electrónico o número de contacto para obtener el código de verificación',
			passwordResetRequired:
				'Debes restablecer tu contraseña antes de iniciar sesión. Sigue las instrucciones enviadas a tu correo electrónico',
			expiredCode:
				'El código de verificación ha expirado. Solicita uno nuevo e inténtalo de nuevo',
		},

		resetPass: {
			userNotFound:
				'El correo electrónico que ingresaste no está registrado. Revisa si hay errores tipográficos o regístrate con una nueva cuenta',
			invalidParameter:
				'Algunos datos ingresados están incompletos o son incorrectos. Revisa tu información e inténtalo de nuevo',
			notAuthorized:
				'La autenticación falló debido a un parámetro de seguridad faltante. Inténtalo nuevamente o contáctanos',
			limitExceeded:
				'Han sido demasiados intentos de restablecimiento de contraseña. Espera un momento e inténtalo de nuevo',
			internalError:
				'Ocurrió un problema. Por favor, inténtalo de nuevo más tarde',
			invalidLambda:
				'No pudimos procesar tu solicitud. Por favor inténtalo de nuevo más tarde.',
			invalidSmsPolicy:
				'No pudimos enviar el SMS para la verificación. Por favor, inténtalo de nuevo más tarde',
			codeMismatch:
				'El código ingresado es incorrecto. Por favor, verifícalo e inténtalo nuevamente',
			expiredCode:
				'El código ingresado expliró. Solicita uno nuevo e inténtalo de nuevo',
			invalidPassword:
				'Las contraseñas deben tener al menos 8 caracteres e incluir una mayúscula, una minúscula, un número y un carácter especial',
		},
	},
	errorsNotFound: {
		pageMissingTitle: '¡Lo sentimos!',
		pageMissingMessage:
			'¡Lo sentimos! La sección que estás buscando puede haber sido eliminada.',
		pageMissingSupport:
			'Por favor, inicia sesión nuevamente para reautenticarte. Si necesitas ayuda, contáctanos.',
		goHome: 'Inicia sesión',
		contactUs: 'Contáctanos',
	},
}
